<template>
  <div :class="$style.container" id="channelCustomer" v-loading.fullscreen.lock.body="loading"
    :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div style="background-color: #fff; height: auto">
      <header style="position: relative; padding-bottom: 10px; display: flex">
        <el-row style="width: 384px; flex-shrink: 0">
          <div style="padding-top: 8px; font-size: 20px; float: left">
            客户管理
          </div>
          <div style="float: right; padding-top: 4px">
            <el-button type="primary" size="small" icon="el-icon-download" @click="daoru">导入导出</el-button>
            <el-button type="success" size="small" icon="el-icon-plus" style="float: right" @click="xinzeng">
              新增经销商
            </el-button>
          </div>
        </el-row>
        <div style="width: 389px; margin: 0 auto">
          <el-button-group>
            <el-button @click="dianji">地图模式</el-button>
            <el-button @click="dianji1">医疗机构</el-button>
            <el-button @click="dianji2">零售终端</el-button>
            <el-button style="
                color: #409eff;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
              ">分销客户</el-button>
          </el-button-group>
        </div>
      </header>
    </div>
    <div style="height: calc(100% - 40px)">
      <el-container style="width: 384px; float: left; height: 100%; padding: 8px 0 10px 0">
        <div style="width: 384px">
          <div style="font-size: 18px; color: #000">
            <!--            <el-row style="margin-top: 4px">-->
            <!--              <el-col :span="12">-->
            <!--                <el-button type="primary" size="small" icon="el-icon-download" @click="daoru">导入导出</el-button>-->
            <!--              </el-col>-->

            <!--              <el-col :span="12">-->
            <!--                <el-button type="success" size="small" icon="el-icon-plus" style="float: right" @click="xinzeng">-->
            <!--                  新增经销商-->
            <!--                </el-button>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
          </div>

          <div ref="scrollbar" style="
              border: 1px solid #dedede;
              width: 382px;
              height: calc(100% - 10px);
            " @click.stop="">
            <el-row style="
                border-bottom: 1px solid #dedede;
                overflow: hidden;
                height: 100%;
              ">
              <el-autocomplete v-model="filterText" placeholder="请输入名称进行快速搜索" :fetch-suggestions="search"
                @select="handleSelect" class="Myinput" style="display: flex; justify-content: center">
                <div slot-scope="{ item }" style="height: 50px; border-bottom: 1px solid #ededed">
                  <div style="font-size: 14px; color: #555555; height: 22px">
                    {{ item.distributor_name }}
                  </div>
                  <div style="
                      font-size: 11px;
                      color: #ccc;
                      float: left;
                      height: 18px;
                    ">
                    地址:{{ item.address }}
                  </div>
                </div>
              </el-autocomplete>

              <el-row style="
                  width: 158px;
                  float: left;
                  border-right: 1px solid #ededed;
                  overflow-y: auto;
                  overflow-x: hidden;
                  height: calc(100% - 41px);
                " class="treeClass">
                <div style="">
                  <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"
                    :default-expanded-keys="[province_id, city_id]" :current-node-key="city_id" node-key="id"
                    class="SizeClass" highlight-current="true" ref="tree">
                    <span style="
                        margin-top: 20px;
                        margin-bottom: 20px;
                        font-size: 14px;
                      " slot-scope="{ node, data }">
                      <img src="../../assets/images/tu1.png" alt="" v-if="node.level === 1"
                        style="height: 16.23px; position: relative; top: 3px" />
                      <img src="../../assets/images/tu2.png" alt="" v-if="node.level === 2" style="height: 16.23px" />

                      <span :class="$style.font">{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
              </el-row>

              <el-row class="constrution-tree2" style="
                  width: 224px;
                  float: right;
                  overflow-y: auto;
                  overflow-x: hidden;
                  height: calc(100% - 41px);
                ">
                <div style="">
                  <el-tree :data="data2" :props="defaultProps" @node-click="handleNodeClick2" class="SizeClass"
                    highlight-current="true" node-key="id" :default-expanded-keys="[distributor_id]"
                    :current-node-key="distributor_id" ref="tree2">
                    <span style="
                        margin-top: 20px;
                        margin-bottom: 20px;
                        font-size: 14px;
                      " slot-scope="{ node, data }">
                      <span style="font-size: 14px; margin-left: -10px">{{ node.label }}</span>
                    </span>
                  </el-tree>
                </div>
              </el-row>
            </el-row>
          </div>
        </div>
      </el-container>
      <div style="
          width: calc(100% - 384px);
          float: left;
          overflow: auto;
          height: 100%;
        ">
        <el-main height="100%" v-if="is_data" style="
            display: flex;
            flex-direction: column;
            height: 100%;
            padding-top: 0;
            margin-left: 15px;
          ">
          <div :class="$style.header" style="flex-shrink: 0">
            <div style="width: 100%; height: 100%">
              <div style="
                  padding-top: 8px;
                  color: #4a90e2;
                  font-size: 20px;
                  float: left;
                  height: 30px;
                ">
                {{ ContactList.distributor_name }}
              </div>

              <div style="float: right; height: 30px">
                <el-button type="warning" size="small" @click="bianji"
                  style="background-color: #ff9901; border: #ff9901 1px solid">
                  编辑
                </el-button>
              </div>

              <div style="
                  float: right;
                  height: 30px;
                  margin-top: 8px;
                  margin-right: 20px;
                ">
                <el-switch v-model="institutionStatus" inactive-text="有效" active-color="#13ce66"
                  @change="setInstitutionStatusBySwitch" disabled> </el-switch>
              </div>
              <div style="
                  float: right;
                  height: 30px;
                  margin-top: 8px;
                  margin-right: 20px;
                ">
                <el-switch v-model="institutionKey_acount" inactive-text="重点" active-color="#13ce66" disabled
                  @change="setInstitutionStatusBySwitch" />
              </div>
            </div>
            <el-row>
              <el-col>
                <div style="border-top: 1px dashed #ededed"></div>
              </el-col>
            </el-row>
          </div>
          <div :class="$style.right" style="overflow-y: auto; flex-grow: 1; margin-top: 0">
            <!-- 地图-->
            <div :style="{ width: '100%', height: '300px' }" style="text-align: center; margin-top: 20px">
              <el-amap vid="amapDemoDealer" :center="center" :zoom="zoom" :amapManager="amapManager" class="amap-demo"
                :plugin="plugin">
                <el-amap-marker :position="center.position" :template="center.template" v-for="center in centers">
                </el-amap-marker>
              </el-amap>
              <!--              <el-button size="mini" type="warning"-->
              <!--                         style="float: left;position: relative;top: -280px;left: 10px;background-color: #ff9901;border: #ff9901 1px solid;"-->
              <!--                         @click="showAmapDialogAction"-->
              <!--              >编辑坐标-->
              <!--              </el-button>-->
              <!--<img src="../../assets/images/tu3.png"  style="float: right;position: relative;top: -180px;right: 39.5%;">-->
            </div>
            <!--                        location-->
            <div :style="{
                width: '100%',
                height: '62px',
                padding: '10px 0px',
                overflow: 'hidden',
                position: 'relative',
              }">
              <div style="
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  top: 32px;
                  left: 0px;
                  cursor: pointer;
                " @click="locationLeftBut">
                <img src="../../assets/images/locationLeft.png" style="width: 20px; height: 20px" />
              </div>
              <div style="
                  width: 50px;
                  height: 50px;
                  float: left;
                  margin-top: 6px;
                  margin-left: 35px;
                  cursor: pointer;
                " @click.stop="addLocation" @click="dialog1 = true">
                <img src="../../assets/images/locationAdd.png" style="width: 50px; height: 50px" />
              </div>
              <div style="float: left; height: 62px; width: 85%; overflow: hidden">
                <div style="
                    height: 62px;
                    position: relative;
                    white-space: nowrap;
                    transition: 0.3s;
                  " :style="{ left: marginValue + 'px', width: widthLocation }">
                  <div :style="{
                      width: '300px',
                      height: '60px',
                      border: '1px solid #ccc',
                      float: 'left',
                      marginLeft: '10px',
                      marginBottom: '10px',
                      backgroundColor: mydiv === j ? '#ecf3fc' : '#fff',
                      borderColor: mydiv === j ? '#4A90E2' : '#ededed',
                    }" v-for="(item, j) in locationInfo" @click="InstitutionClient(item, j)" class="mydiv"
                    style="display: inline-block; white-space: nowrap">
                    <div style="float: left">
                      <p style="
                          margin: 20px 10px;
                          background: #999;
                          color: #fff;
                          border-radius: 50%;
                          width: 20px;
                          height: 20px;
                          text-align: center;
                          line-height: 20px;
                        ">
                        {{ j + 1 }}
                      </p>
                    </div>
                    <div style="float: left">
                      <p style="
                          padding: 10px 0px;
                          margin: 0;
                          color: #4a4a4a;
                          font-size: 16px;
                          width: 200px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        ">
                        {{ item.location_name }}
                      </p>
                      <p style="
                          padding: 0px 0px;
                          margin: 0;
                          color: #b0b5b9;
                          font-size: 14px;
                          width: 200px;
                          overflow: hidden;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                        ">
                        {{ item.address }}
                      </p>
                    </div>
                    <div style="float: left">
                      <span style="
                          float: right;
                          margin-top: 10px;
                          padding: 0px 10px;
                          background: #ff9901;
                          color: #fff;
                          border-radius: 5px;
                          cursor: pointer;
                          font-size: 14px;
                          height: 18px;
                          line-height: 18px;
                        " @click.stop="editorLocation(item)" @click="dialog1 = true">编辑</span>
                    </div>
                    <div style="float: left" v-if="item.primary == 'T'">
                      <span style="
                          font-size: 14px;
                          color: #7ed321;
                          margin: 10px;
                          line-height: 30px;
                        ">主要</span>
                    </div>
                  </div>
                </div>
              </div>

              <div style="
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  top: 32px;
                  right: 0px;
                  cursor: pointer;
                " @click="locationRightBut">
                <img src="../../assets/images/locationRight.png" style="width: 20px; height: 20px" />
              </div>
            </div>

            <div class="message" style="margin-top: 30px">
              <el-row>
                <el-col :span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">名称</el-col>
                  <el-col :span="9" style="color: #4a90e2; font-size: 14px">{{ ContactList.distributor_name }}</el-col>
                </el-col>
                <el-col :span="3" style="font-size: 14px; font-weight: bold">经销商编码</el-col>
                <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.distributor_code }}</el-col>
              </el-row>
              <el-row style="margin-top: 24px">
                <el-col :span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">类别</el-col>
                  <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.distributor_type_name }}
                  </el-col>
                </el-col>
                <el-col :span="3" style="font-size: 14px; font-weight: bold">级别</el-col>
                <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.distributor_grade_name }}
                </el-col>
              </el-row>
              <el-row style="margin-top: 24px">
                <el-col span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">省份</el-col>
                  <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.province_name }}</el-col>
                </el-col>

                <el-col :span="3" style="font-size: 14px; font-weight: bold">城市</el-col>
                <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.city_name }}</el-col>
              </el-row>
              <el-row style="margin-top: 24px">
                <el-col span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">区县</el-col>
                  <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.county_name }}</el-col>
                </el-col>

                <el-col :span="3" style="font-size: 14px; font-weight: bold">地址</el-col>
                <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.address }}</el-col>
              </el-row>
              <!-- <el-row style="margin-top: 24px">

                <el-col :span="3" style="font-size: 14px; font-weight: bold"
                  >地址</el-col
                >
                <el-col :span="21" style="color: #4a4a4a; font-size: 14px">{{
                  ContactList.address
                }}</el-col>
              </el-row> -->
              <el-row style="margin-top: 24px">
                <el-col span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">联系电话</el-col>
                  <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.telephone }}</el-col>
                </el-col>
                <el-col :span="3" style="font-size: 14px; font-weight: bold">邮政编码</el-col>
                <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.postcode }}</el-col>
              </el-row>
              <el-row style="margin-top: 24px">
                <el-col span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">官方网址</el-col>
                  <el-col :span="9" style="color: #4a4a4a; font-size: 14px">{{ ContactList.website }}</el-col>
                </el-col>
                <el-col :span="3" style="font-size: 14px; font-weight: bold">分类级别</el-col>
                <el-col :span="9" style="font-size: 14px; color: #4a4a4a">{{ ContactList.account_level_name }}</el-col>
              </el-row>
              <el-row style="margin-top: 24px">
                <el-col span="12">
                  <el-col :span="6" style="font-size: 14px; font-weight: bold">已核查</el-col>
                  <el-col :span="9" style="color: #4a4a4a; font-size: 14px">
                    <el-switch v-model="ContactList.account_verified" active-value="T" inactive-value="F"
                      active-color="#13ce66" disabled />
                  </el-col>
                </el-col>
              </el-row>
            </div>

            <div class="arraylist" style="margin-top: 56px">
              <el-row>
                <el-col :span="12" style="color: #4a90e2; font-size: 20px">
                  联系人列表
                </el-col>
                <el-col :span="12">
                  <el-button type="success" size="small" icon="el-icon-plus" style="float: right" @click="tianjia">
                    添加联系人
                  </el-button>
                </el-col>
              </el-row>

              <el-row style="margin-top: 20px">
                <el-col :span="24">
                  <el-table border :data="listData" stripe style="width: 100%" header-cell-class-name="headerStyle"
                    :default-sort="{ prop: 'date', order: 'descending' }">
                    <el-table-column fixed type="index" :index="1" label="序号" style="font-size: 20px; color: #585757"
                      width="75"></el-table-column>
                    <el-table-column prop="contact_name" label="姓名" min-width="100" sortable> </el-table-column>
                    <el-table-column prop="gender_name" label="性别" min-width="100" sortable> </el-table-column>
                    <el-table-column prop="department" label="所属部门" min-width="110" sortable> </el-table-column>
                    <el-table-column prop="job_title" label="职务" min-width="100" sortable> </el-table-column>
                    <el-table-column prop="mobile" label="联系电话" min-width="150" sortable> </el-table-column>
                    <el-table-column prop="status_name" label="状态" min-width="100" sortable> </el-table-column>
                    <el-table-column fixed="right" label="操作" width="72px">
                      <template slot-scope="scope">
                        <el-button type="warning" size="mini" style="
                            margin-right: 10px;
                            float: left;
                            background-color: #ff9901;
                            border: #ff9901 1px solid;
                          " @click="handleEdit(scope.$index, scope.row)">详情
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-main>
        <div id="div4" v-if="!is_data" style="
            width: 100%;
            height: 100%;
            margin: 0 auto;
            margin-top: 250px;
            text-align: center;
          ">
          <img src="../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" style="margin: 0 auto; display: block"
            alt="" />
        </div>
      </div>
    </div>

    <!--编辑location-->
    <el-dialog :visible.sync="dialog1" :before-close="handleClose" width="900px" :show-close="false"
      style="vertical-align: center; :#FFF9F3 ; margin-top: -100px">
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              GPS坐标
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click.stop="baocunLocation" @click="dialog1 = false">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="dialog1 = false">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>

        <div class="amap-page-container" style="height: 300px">
          <el-amap-search-box :default="searchStr" class="search-box" :search-option="searchOption"
            :on-search-result="onSearchResult" style="position: relative; top: 20px; left: 20px"></el-amap-search-box>
          <el-amap vid="mapDemo2" :center="mapCenter" :zoom="12" :plugin="plugin" :amapManager="amapManager"
            class="amap-demo" style="position: relative; top: -43px; margin: 0">
            <el-amap-marker :position="marker" :draggable="true" :events="edit_markers.events"
              v-for="marker in markers2"> </el-amap-marker>
          </el-amap>
          <div align="center" style="width: 100%; margin-top: -60px">
            <span style="
                position: relative;
                top: -35px;
                background-color: #b6bbbf;
                border: 1px solid #ccc;
                color: #fff;
                font-size: 14px;
                border-radius: 5px;
                padding: 2px 5px;
              ">请拖拽地图上的图标进行修改</span>
          </div>
        </div>

        <div style="margin-top: 10px" class="amap">
          <el-form ref="formapLocation" :model="formapLocation" label-width="80px">
            <el-form-item label="名称">
              <el-input v-model="formapLocation.location_name"></el-input>
            </el-form-item>
            <el-form-item label="地址">
              <el-input v-model="formapLocation.address"></el-input>
            </el-form-item>
            <el-form-item label="设为主要">
              <el-switch v-model="formapLocation.status" active-color="#13ce66" active-value="ACTIVE"
                inactive-value="INACTIVE"> </el-switch>
            </el-form-item>
            <el-form-item label="启用">
              <el-switch v-model="formapLocation.location_status" active-color="#13ce66" active-value="ACTIVE"
                inactive-value="INACTIVE"> </el-switch>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <!--导入导出 -->
    <el-dialog :visible.sync="dialogVisible" width="850px" :show-close="false"
      style="vertical-align: center; :#FFF9F3 ">
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              数据导入与导出
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="danger" size="small" @click="closeModal2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="subjectList" style="margin-top: 20px">
          <el-form ref="form" label-width="160px" :model="form" style="font-size: 14px">
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载经销商数据">
                  <el-select v-model="form.name" placeholder="请选择省份" style="float: left" clearable>
                    <el-option v-for="item in dataList" :key="item.id" :label="item.label" :value="item.id"
                      :change="changeInstitution()"> </el-option>
                  </el-select>

                  <el-button type="primary" size="small" style="margin-left: 21px" @click="xiazai">下载</el-button>

                  <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i class="el-icon-document"></i>{{
                    retailStoreData_name + ".xls" }} </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载经销商坐标">
                  <el-select v-model="form.position" placeholder="请选择省份" style="float: left" clearable>
                    <el-option v-for="item in dataList" :key="item.id" :label="item.label" :value="item.id"
                      :change="changeInstitution1()"> </el-option>
                  </el-select>

                  <el-button type="primary" size="small" style="margin-left: 21px" @click="xiazai3">下载</el-button>

                  <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i class="el-icon-document"></i>{{
                    retailStoreData_location + ".xls" }} </span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row style="margin-left: 10px">
              <el-col>
                <el-form-item label="下载联系人数据">
                  <el-select v-model="form.title" placeholder="请选择省份" style="float: left" clearable>
                    <el-option v-for="item in dataList" :key="item.id" :label="item.label" :value="item.id"
                      :change="changeInstitution2()"> </el-option>
                  </el-select>

                  <el-button type="primary" size="small" style="margin-left: 21px" @click="xiazai2">下载</el-button>

                  <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i class="el-icon-document"></i>{{
                    retailStoreData_title + ".xls" }} </span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-left: 10px; margin-top: 30px">
              <el-form-item label="经销商数据导入模板">
                <a style="text-decoration: none; color: #ffff" class="el-button el-button--primary el-button--small"
                  href="../../../static/经销商数据导入模板.xlsx" download="经销商数据导入模板.xlsx">下载</a>
                <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i
                    class="el-icon-document"></i>经销商数据导入模板.xls </span>
              </el-form-item>
            </el-row>
            <el-row style="
                margin-left: 10px;
                display: flex;
                align-items: center;
                padding-right: 30px;
              ">
              <el-form-item label="上传经销商数据" style="margin-bottom: 0"> </el-form-item>
              <div style="
                  border: 1px solid #ededed;
                  height: 30px;
                  flex-grow: 1;
                  margin-right: 20px;
                ">
                <span style="position: relative; top: 8px; left: 5px">{{ file }}</span>
              </div>
              <el-upload class="upload-demo" ref="upload" accept=".xlsx,.xls" action="" :file-list="fileList"
                :show-file-list="false" :on-change="handleChange" :on-success="handleSuccess" :limit="1"
                :auto-upload="false">
                <el-button slot="trigger" size="small" style="
                    background-color: #7ed321;
                    border: 1px solid #7ed321;
                    color: white;
                  ">选择文件
                </el-button>
                <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick">导入数据
                </el-button>
              </el-upload>
            </el-row>

            <el-row style="margin-left: 10px; margin-top: 30px">
              <el-form-item label="经销商坐标模板">
                <a style="text-decoration: none; color: #ffff" class="el-button el-button--primary el-button--small"
                  href="../../../static/经销商坐标数据导入模板.xlsx" download="经销商坐标数据导入模板.xlsx">下载</a>
                <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i
                    class="el-icon-document"></i>经销商坐标数据导入模板.xls </span>
              </el-form-item>
            </el-row>
            <el-row style="
                margin-left: 10px;
                display: flex;
                align-items: center;
                padding-right: 30px;
              ">
              <el-form-item label="上传经销商坐标" style="margin-bottom: 0"> </el-form-item>
              <div style="
                  border: 1px solid #ededed;
                  height: 30px;
                  flex-grow: 1;
                  margin-right: 20px;
                ">
                <span style="position: relative; top: 8px; left: 5px">{{ file2 }}</span>
              </div>
              <el-upload class="upload-demo" ref="upload3" accept=".xlsx,.xls" action="" :file-list="fileList3"
                :show-file-list="false" :on-change="handleChange3" :on-success="handleSuccess3" :limit="1"
                :auto-upload="false">
                <el-button slot="trigger" size="small" style="
                    background-color: #7ed321;
                    border: 1px solid #7ed321;
                    color: white;
                  ">选择文件
                </el-button>
                <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick3">导入数据
                </el-button>
              </el-upload>
            </el-row>

            <el-row style="margin-left: 10px; margin-top: 30px">
              <el-form-item label="联系人数据导入模板">
                <a style="text-decoration: none; color: #ffff" class="el-button el-button--primary el-button--small"
                  href="../../../static/联系人数据导入模板.xlsx" download="联系人数据导入模板.xlsx">下载</a>
                <span style="font-size: 14px; color: #585757; margin-left: 11px"> <i
                    class="el-icon-document"></i>联系人数据导入模板.xls </span>
              </el-form-item>
            </el-row>
            <el-row style="
                margin-left: 10px;
                display: flex;
                align-items: center;
                padding-right: 30px;
              ">
              <el-form-item label="上传联系人数据" style="margin-bottom: 0"> </el-form-item>
              <div style="
                  border: 1px solid #ededed;
                  height: 30px;
                  flex-grow: 1;
                  margin-right: 20px;
                ">
                <span style="position: relative; top: 8px; left: 5px">{{ file3 }}</span>
              </div>
              <el-upload class="upload-demo" ref="upload2" accept=".xlsx,.xls" action="" :file-list="fileList2"
                :show-file-list="false" :on-change="handleChange2" :on-success="handleSuccess2" :limit="1"
                :auto-upload="false">
                <el-button slot="trigger" size="small" style="
                    background-color: #7ed321;
                    border: 1px solid #7ed321;
                    color: white;
                  ">选择文件
                </el-button>
                <el-button style="margin-left: 10px" size="small" type="warning" @click="imortDataClick2">导入数据
                </el-button>
              </el-upload>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!--新增经销商-->
    <el-dialog :visible.sync="dialogVisible5" width="900px" :show-close="false"
      style="vertical-align: center; :#FFF9F3 ">
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              新增经销商
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun4">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="quxiao">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>

        <div class="subjectList" style="margin-top: 20px">
          <el-form ref="pushlist" :model="pushlist" label-width="120px" :rules="rules" hide-required-asterisk>
            <el-row>
              <el-col :span="12">
                <el-form-item label="名称" prop="distributor_name" class="channel_star">
                  <el-input v-model="pushlist.distributor_name" placeholder="请输入名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="编码" prop="distributor_code" class="channel_star">
                  <el-input v-model="pushlist.distributor_code" placeholder="请输入经销商编码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="类别" prop="distributor_type" class="channel_star">
                  <el-select v-model="pushlist.distributor_type" placeholder="请选择" style="width: 100%" @change="fangfa2"
                    clearable>
                    <el-option v-for="item in TypeList" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="级别">
                  <el-select v-model="pushlist.distributor_grade_name" placeholder="请选择" style="width: 100%" clearable>
                    <el-option v-for="item in GardeList" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="省份" prop="province_id" class="channel_star">
                  <el-select v-model="pushlist.province_id" placeholder="请选择" style="width: 100%" @change="fangfa"
                    clearable>
                    <el-option v-for="item in data" :key="item.id" :label="item.label" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="城市" prop="city_id" class="channel_star">
                  <el-select v-model="pushlist.city_id" placeholder="请选择" style="width: 100%" clearable
                    @change="getCountyData">
                    <el-option v-for="item in CityList" :key="item.city_id" :label="item.city_name"
                      :value="item.city_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="区县" prop="county_id">
                  <el-select v-model="pushlist.county_id" placeholder="请选择" style="width: 100%" clearable>
                    <el-option v-for="item in CountyList" :key="item.county_id" :label="item.county_name"
                      :value="item.county_id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址">
                  <el-input v-model="pushlist.address" placeholder="请输入地址"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- <el-form-item label="地址">
              <el-input
                v-model="pushlist.address"
                placeholder="请输入地址"
              ></el-input>
            </el-form-item> -->

            <el-row>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input v-model="pushlist.telephone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮政编码">
                  <el-input v-model="pushlist.postcode" placeholder="请输入邮政编码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="官方网址">
              <el-input v-model="pushlist.website" placeholder="请输入官方网址"></el-input>
            </el-form-item>

            <el-form-item label="备注">
              <el-input v-model="pushlist.comments" placeholder="请输入备注信息" type="textarea"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="有效">
                  <el-switch v-model="pushlist.status" active-color="#13ce66" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="重点">
                  <el-switch v-model="pushlist.key_acount" active-color="#13ce66" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="分类级别">
                  <el-select v-model="pushlist.account_level" filterable placeholder="请选择分类级别" style="width: 100%"
                    clearable>
                    <el-option v-for="item in AccountLevelList" :key="item.key" :label="item.value1" :value="item.key">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="已核查">
                  <el-switch v-model="pushlist.account_verified" active-color="#13ce66" active-value="T"
                    inactive-value="F" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!--编辑1-->
    <el-dialog :visible.sync="dialogVisible2" width="900px" :show-close="false"
      style="vertical-align: center; :#FFF9F3 ">
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              经销商详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun3">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="clickExtension">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <el-tabs v-model="activeName2" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="subjectList" style="margin-top: 20px">
              <el-form ref="formlist" :model="formlist" label-width="120px" :rules="rules" hide-required-asterisk>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="名称" prop="distributor_name" class="channel_star">
                      <el-input v-model="formlist.distributor_name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="编码" prop="distributor_code" class="channel_star">
                      <el-input v-model="formlist.distributor_code"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="类别" prop="distributor_type" class="channel_star">
                      <el-select v-model="formlist.distributor_type" placeholder="请选择" style="width: 100%"
                        @change="fangfa2" clearable>
                        <el-option v-for="item in TypeList" :key="item.key" :label="item.value1" :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="级别">
                      <el-select v-model="formlist.distributor_grade_name" placeholder="请选择" style="width: 100%"
                        clearable>
                        <el-option v-for="item in GardeList" :key="item.key" :label="item.value1" :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="省份" prop="province_id" class="channel_star">
                      <el-select v-model="formlist.province_id" placeholder="请选择" @change="fangfa" style="width: 100%"
                        clearable>
                        <el-option v-for="item in data" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="城市" prop="city_id" class="channel_star">
                      <el-select v-model="formlist.city_id" placeholder="请选择" style="width: 100%"
                        @change="getCountyData" clearable>
                        <el-option v-for="item in CityList" :key="item.city_id" :label="item.city_name"
                          :value="item.city_id"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="区县" prop="county_id">
                      <el-select v-model="formlist.county_id" filterable placeholder="请选择区县" style="width: 100%"
                        clearable>
                        <el-option v-for="item in CountyList" :key="item.county_id" :label="item.county_name"
                          :value="item.county_id"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="地址">
                      <el-input v-model="pushlist.address" placeholder="请输入地址"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- mine -->
                <!-- <el-form-item label="地址">
                  <el-input v-model="formlist.address"></el-input>
                </el-form-item> -->

                <el-row>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="formlist.telephone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="邮政编码">
                      <el-input v-model="formlist.postcode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="官方网址">
                  <el-input v-model="formlist.website"></el-input>
                </el-form-item>

                <el-form-item label="备注">
                  <el-input v-model="formlist.comments" placeholder="请输入备注信息" type="textarea"></el-input>
                </el-form-item>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="有效">
                      <el-switch v-model="formlist.status" active-color="#13ce66" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="重点">
                      <el-switch v-model="formlist.key_acount" active-color="#13ce66" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="分类级别">
                      <el-select v-model="formlist.account_level" filterable placeholder="请选择分类级别" style="width: 100%"
                        clearable>
                        <el-option v-for="item in AccountLevelList" :key="item.key" :label="item.value1"
                          :value="item.key"> </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="已核查">
                      <el-switch v-model="formlist.account_verified" active-color="#13ce66" active-value="T"
                        inactive-value="F" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items, j) in extendedInfo">
            <div class="subjectList" style="margin-top: 20px">
              <el-form hide-required-asterisk :ref="'list' + j" label-width="27%" v-for="(item, j) in items.fieldArray"
                :model="item" :key="item.field_id">
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input v-model="item.field_value" placeholder="请输入文本"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input v-model="item.field_value" placeholder="请输入数字" type="number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%" >-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader v-model="item.field_value" :options="item.listArray" style="width: 100%" filterable
                      :show-all-levels="false" :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }" clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-table :data="item.field_value" border style="width: 100%">
                      <el-table-column type="index" label="序号" width="50"> </el-table-column>
                      <el-table-column prop="dept_name" label="标准科室" v-if="item.array_dept !== 'NONE'">
                      </el-table-column>
                      <el-table-column prop="product_name" label="产品" v-if="item.array_product !== 'NONE'">
                      </el-table-column>
                      <el-table-column prop="sku_name" label="SKU"
                        v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"> </el-table-column>
                      <el-table-column prop="date_name" label="日期" v-if="item.array_date !== 'NONE'"> </el-table-column>
                      <el-table-column prop="field_value" label="数值"> </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button @click="handleTableClick(scope.$index, scope.row, item)" style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            " size="small">详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button size="small" icon="el-icon-plus" style="
                        float: left;
                        margin-left: 27%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      " @click="addNewTable(item)">添加新数据
                    </el-button>
                  </el-col>
                  <el-col :span="24" v-if="item.isAddTable" id="addTable" style="
                      margin-left: 30%;
                      width: 70%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    ">
                    <el-col :span="14">
                      <el-form ref="addTable" :model="item.addTableList" style="margin-top: 20px"
                        hide-required-asterisk>
                        <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id" class="channel_star"
                          :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }">
                          <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                            style="width: 70%; float: right" clearable>
                            <el-option v-for="item in administrativeList" :key="item.key" :label="item.value1"
                              :value="item.key"> </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                          class="channel_star" :rules="{ required: true, message: '产品不能为空' }">
                          <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                            style="width: 70%; float: right" @change="getSkuList(item)" clearable>
                            <el-option v-for="item in productList" :key="item.key" :label="item.value1"
                              :value="item.key"> </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" class="channel_star"
                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'" prop="sku_id"
                          :rules="{ required: true, message: 'SKU不能为空' }">
                          <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                            style="width: 70%; float: right" clearable>
                            <el-option v-for="item in SkuList" :key="item.key" :label="item.value1" :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="日期" class="channel_star"
                          v-if="item.array_date !== 'NONE' && item.array_date !== ''" prop="date_name"
                          :rules="{ required: true, message: '日期不能为空' }">
                          <el-date-picker v-model="item.addTableList.info_date" type="year"
                            style="width: 70%; float: right" format="yyyy年" value-format="yyyy年" placeholder="选择年"
                            v-if="item.array_date == 'YEAR'">
                          </el-date-picker>
                          <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                            style="width: 70%; float: right"></quarter>
                          <el-date-picker v-model="item.addTableList.info_date" type="month"
                            style="width: 70%; float: right" format="yyyy年MM月" value-format="yyyy年MM月" placeholder="选择月"
                            v-if="item.array_date == 'MONTH'">
                          </el-date-picker>
                          <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                            style="width: 70%; float: right"></monthComponent>
                          <el-date-picker v-model="item.addTableList.info_date" type="date" placeholder="选择日期"
                            style="width: 70%; float: right" format="yyyy年MM月dd日" value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="数值" prop="field_value" class="channel_star"
                          :rules="{ required: true, message: '数值不能为空' }">
                          <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                            style="width: 70%; float: right"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button size="small" style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          " @click="addTableData(item)">保存
                        </el-button>
                        <el-button style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          " @click="delateTableData(item)" v-if="delateFalse" size="small">删除
                        </el-button>
                        <el-button size="small" style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          " @click="cancelTableData(item)">取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="照片图库" name="third">
            <div class="photoList" style="display: flex; flex-wrap: wrap">
              <div class="upload" style="float: left" @click.stop="openDetail">
                <div class="d1"></div>
                <div class="d2"></div>
              </div>
              <div class="imgInfo" style="align-items: flex-start" v-for="item in imgArray"
                @click.stop="editPhoto(item)">
                <img :src="item.url" style="
                    width: 120px;
                    height: 120px;
                    border-radius: 5px;
                    display: block;
                  " />
                <div style="min-height: 18px; width: 120px">
                  <el-tag v-for="bq in item.tag" :key="bq.text" :disable-transitions="false" style="
                      background-color: #ba9ee6;
                      color: white;
                      font-weight: bold;
                    ">
                    {{ bq.text }}
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="photoDetail" v-if="isDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    ">
                    照片详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button type="primary" class="button" @click="submitPhoto">
                      保存
                    </el-button>
                    <el-button type="danger" class="button" @click="closeDetail">
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      ">照片上传</span>
                    <el-button type="danger" style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      " @click.stop="deletePhoto">删除照片
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload ref="photoUpload" class="upload-demo" drag accept=".jpg,.png,.jpeg"
                      action="https://cn2.saasyun.com:15041/uploadphoto" :auto-upload="false"
                      :before-upload="getUuidAgenda" :on-success="getPhotoIdAgenda" :on-change="beforeUpload"
                      :data="categoryAgenda">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input placeholder="请输入照片的说明" style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      " v-model="tagText" @keyup.enter.native="addTag" @input.native="change($event)"></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag closable v-for="tag in tags" :key="tag.text" :disable-transitions="false"
                      @close="tagClose(tag)" style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      ">
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附加文件" name="four">
            <div class="">
              <el-col style="color: #2b92fa; margin-bottom: 10px">
                文件总数：{{ fileTable.length }}个（视频：{{ statistics.mp4Num ? statistics.mp4Num : 0 }}个，幻灯片：
                {{ statistics.slideNum ? statistics.slideNum : 0 }}个，图片：{{ statistics.imgNum ? statistics.imgNum : 0
                }}个，文档：{{
                statistics.docNum ? statistics.docNum : 0
                }}个，其他：{{ statistics.restsNum ? statistics.restsNum : 0 }}个）
              </el-col>
              <el-table :data="fileTable" border>
                <el-table-column sortable label="文件名称" width="180">
                  <template slot-scope="scope">
                    {{ scope.row.file_name }}
                    <el-tag v-for="bq in scope.row.tag" :key="bq.text" :disable-transitions="false" style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      ">
                      {{ bq.text }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="category" label="文件类型">
                  <template slot-scope="scope">
                    {{ isFileType(scope.row.category) }}
                  </template>
                </el-table-column>
                <el-table-column sortable prop="file_size" label="文件大小">
                  <template slot-scope="scope">
                    <span>{{ getFileSize(scope.row.file_size) }}</span>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="status" label="状态">
                  <template slot-scope="scope">
                    {{ scope.row.status == "ACTIVE" ? "有效" : "无效" }}
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="editFile(scope.$index, scope.row)" type="warning" size="mini">详情 </el-button>
                    <el-button @click="downloadFile(scope.row)" type="primary" size="mini">下载 </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button type="success" size="small" icon="el-icon-plus" style="margin-top: 10px"
                @click.stop="openFileDetail">添加文件 </el-button>
            </div>
            <div class="photoDetail" v-if="fileDetail">
              <el-row>
                <el-col :span="24" style="padding: 20px 20px">
                  <div style="
                      color: #2b92fa;
                      font-size: 18px;
                      display: inline-block;
                      float: left;
                    ">
                    文件详情
                  </div>
                  <div style="display: inline-block; float: right">
                    <el-button type="primary" class="button" @click.stop="submitFiles">
                      保存
                    </el-button>
                    <el-button type="danger" class="button" @click.stop="closeFileDetail">
                      关闭
                    </el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row style="margin: 10px 20px">
                <el-col span="12">
                  <el-col span="4" style="margin-top: 20px; margin-right: 20px">
                    <span style="
                        display: block;
                        margin-bottom: 20px;
                        margin-left: 4px;
                        font-weight: bold;
                      ">文件上传</span>
                    <el-button type="danger" style="
                        width: 70px;
                        height: 30px;
                        padding: 5px;
                        font-size: 10px;
                        background-color: #d9443d;
                        border-color: #d9443d;
                      " @click.stop="deleteFile">删除文件
                    </el-button>
                  </el-col>
                  <el-col span="16">
                    <el-upload ref="uploadFile" drag :action="getUrl()" :before-upload="beforeFileUpload"
                      :on-success="fileSuccess" :auto-upload="false">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                  </el-col>
                </el-col>
                <el-col span="12">
                  <el-col style="margin-left: 20px; margin-top: 10px">
                    <span style="font-weight: bold">设置标签</span>
                    <el-input placeholder="请输入文件的说明" style="
                        display: inline-block;
                        margin-left: 10px;
                        width: 300px;
                      " v-model="fileTag" @keyup.enter.native="addFileTag"></el-input>
                  </el-col>
                  <el-col style="width: 300px; margin-left: 85px">
                    <el-tag closable v-for="tag in fileTags" :key="tag.text" :disable-transitions="false"
                      @close="fileTagClose(tag)" style="
                        background-color: #ba9ee6;
                        color: white;
                        font-weight: bold;
                      ">
                      {{ tag.text }}
                    </el-tag>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <!--添加店员-->
    <el-dialog :visible.sync="dialogVisible6" width="600px" :show-close="false"
      style="vertical-align: center; margin-top: -70px">
      <div style="margin-top: -40px">
        <el-row style="border-bottom: 2px dotted #e7eaec; padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              添加联系人
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun2">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="quxiao2">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div class="DianClass" style="margin-top: 20px">
          <el-form ref="clerkadd" :model="clerkadd" label-width="150px" hide-required-asterisk>
            <el-row>
              <el-col :span="22">
                <el-form-item label="联系人编码" class="channel_star" prop="contact_code"
                  :rules="[{ required: true, message: '联系人编码不能为空' }]">
                  <el-input v-model="clerkadd.contact_code" placeholder="请输入联系人编码"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <el-form-item label="所属部门">
                  <el-input v-model="clerkadd.department" placeholder="请输入所属部门"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <el-form-item label="职务">
                  <el-input v-model="clerkadd.job_title" placeholder="请输入职务"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22">
                <el-form-item label="姓名" prop="contact_name" class="channel_star"
                  :rules="[{ required: true, message: '姓名不能为空' }]">
                  <el-input v-model="clerkadd.contact_name" placeholder="请输入姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="性别">
                  <el-select v-model="clerkadd.gender" style="width: 100%" placeholder="请选择" clearable>
                    <el-option label="男" value="M"></el-option>
                    <el-option label="女" value="F"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!--                        <el-row >-->
            <!--                            <el-col :span="22">-->
            <!--                                <el-form-item label="职称">-->
            <!--                                    <el-select v-model="clerkadd.pro_title_id" filterable style="width:100%">-->
            <!--                                        <el-option-->
            <!--                                                v-for="item in prolist"-->
            <!--                                                :key="item.key"-->
            <!--                                                :label="item.value1"-->
            <!--                                                :value="item.key">-->
            <!--                                        </el-option>-->
            <!--                                    </el-select>-->
            <!--                                </el-form-item>-->
            <!--                            </el-col>-->
            <!--                        </el-row>-->

            <el-row>
              <el-col :span="22">
                <el-form-item label="联系电话">
                  <el-input v-model="clerkadd.mobile" placeholder="请输入联系电话"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="电子邮件">
                  <el-input v-model="clerkadd.email" placeholder="请输入电子邮箱"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="生日">
                  <el-date-picker v-model="clerkadd.birthday" type="date" value-format="yyyy-MM-dd"
                    placeholder="请选择出生日期" style="width: 100%"> </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="爱好">
                  <el-input v-model="clerkadd.hobby" placeholder="请输入个人爱好"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="22">
                <el-form-item label="在职">
                  <el-switch v-model="clerkadd.status" active-color="#13ce66"> </el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!--联系人详情-->
    <el-dialog :visible.sync="dialogVisible3" width="900px" :show-close="false" id="contact"
      style="vertical-align: center; margin-top: -70px">
      <div style="margin-top: -40px">
        <el-row style="padding-bottom: 10px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              联系人详情
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="baocun">
                保存
              </el-button>
              <el-button type="danger" size="small" @click="concate">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>

        <el-tabs v-model="activeName1" @tab-click="handleClickTabs">
          <el-tab-pane label="基本信息" name="first">
            <div class="DianClass" style="margin-top: 20px">
              <el-form ref="clerkClass" :model="clerkClass" label-width="150px" hide-required-asterisk>
                <!--                        <el-row >-->
                <!--                            <el-col :span="22">-->
                <!--                                <el-form-item-->
                <!--                                        label="联系人编码"-->
                <!--                                        prop="contact_code"-->
                <!--                                        :rules="[-->
                <!--                                            { required: true, message: '联系人编码不能为空'},-->
                <!--                                        ]"-->
                <!--                                >-->
                <!--                                    <el-input v-model="clerkClass.contact_code" placeholder="请输入联系人详情" ></el-input>-->
                <!--                                </el-form-item>-->
                <!--                            </el-col>-->
                <!--                        </el-row>-->
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="所属部门">
                      <el-input v-model="clerkClass.department" placeholder="请输入所属部门"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="职务">
                      <el-input v-model="clerkClass.job_title" placeholder="请输入职务"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="姓名" class="channel_star" prop="contact_name"
                      :rules="[{ required: true, message: '姓名不能为空' }]">
                      <el-input v-model="clerkClass.contact_name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-select v-model="clerkClass.gender" style="width: 100%" placeholder="请选择" clearable>
                        <el-option label="男" value="M"></el-option>
                        <el-option label="女" value="F"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="联系电话">
                      <el-input v-model="clerkClass.mobile" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input v-model="clerkClass.email" placeholder="请输入电子邮箱"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="生日">
                      <el-date-picker v-model="clerkClass.birthday" type="date" value-format="yyyy-MM-dd"
                        placeholder="请选择出生日期" style="width: 100%"> </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="爱好">
                      <el-input v-model="clerkClass.hobby" placeholder="请输入个人爱好"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="在职">
                      <el-switch v-model="clerkClass.status" active-color="#13ce66"> </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="items.group_name" :name="items.name" v-for="(items, j) in extendedInfo1">
            <div class="subjectList" style="margin-top: 20px">
              <el-form hide-required-asterisk :ref="'contactList' + j" label-width="15%"
                v-for="(item, j) in items.fieldArray" :model="item" :key="item.field_id">
                <el-col span="24" v-if="item.input_type == 'TEXT'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input v-model="item.field_value" placeholder="请输入文本"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input v-model="item.field_value" placeholder="请输入数字" type="number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间" style="width: 100%"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                  <el-form-item :label="item.label">
                    <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T" inactive-value="F">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <!--                                        <el-select v-model="item.field_value" :multiple="item.multiple == 'T'" placeholder="请选择" style="width: 100%"  clearable>-->
                    <!--                                            <el-option-->
                    <!--                                                    v-for="item in item.listArray"-->
                    <!--                                                    :key="item.key"-->
                    <!--                                                    :label="item.value1"-->
                    <!--                                                    :value="item.key">-->
                    <!--                                            </el-option>-->
                    <!--                                        </el-select>-->
                    <el-cascader v-model="item.field_value" :options="item.listArray" style="width: 100%" filterable
                      :show-all-levels="false" :props="{
                        multiple: item.multiple == 'T' ? true : false,
                        checkStrictly: true,
                      }" clearable></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-table :data="item.field_value" border style="width: 100%">
                      <el-table-column type="index" label="序号" width="50"> </el-table-column>
                      <el-table-column prop="dept_name" label="标准科室" v-if="item.array_dept !== 'NONE'">
                      </el-table-column>
                      <el-table-column prop="product_name" label="产品" v-if="item.array_product !== 'NONE'">
                      </el-table-column>
                      <el-table-column prop="sku_name" label="SKU"
                        v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"> </el-table-column>
                      <el-table-column prop="date_name" label="日期" v-if="item.array_date !== 'NONE'"> </el-table-column>
                      <el-table-column prop="field_value" label="数值"> </el-table-column>
                      <el-table-column fixed="right" label="操作" width="80">
                        <template slot-scope="scope">
                          <el-button @click="handleTableClick(scope.$index, scope.row, item)" style="
                              background-color: rgb(255, 153, 1);
                              border: 1px solid rgb(255, 153, 1);
                              color: #fff;
                            " size="small">详情
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-col :span="24" style="margin-bottom: 10px">
                    <el-button size="small" icon="el-icon-plus" style="
                        float: left;
                        margin-left: 15%;
                        background-color: #6cc584;
                        border: 1px solid #6cc584;
                        color: #fff;
                      " @click="addNewTable(item)">添加新数据
                    </el-button>
                  </el-col>
                  <el-col :span="24" v-if="item.isAddTable" id="addTableHcp" style="
                      margin-left: 15%;
                      width: 85%;
                      background: #edf3fb;
                      border: 1px solid #ecdfe6;
                      margin-bottom: 10px;
                      border-radius: 10px;
                    ">
                    <el-col :span="14">
                      <el-form ref="addTableHcp" :model="item.addTableList" style="margin-top: 20px"
                        hide-required-asterisk>
                        <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id" :rules="{
                            required: true,
                            message: '标准科室不能为空',
                          }" class="channel_star">
                          <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                            style="width: 70%; float: right" clearable>
                            <el-option v-for="item in administrativeList" :key="item.key" :label="item.value1"
                              :value="item.key"> </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品" v-if="item.array_product !== 'NONE'" prop="product_id"
                          class="channel_star" :rules="{ required: true, message: '产品不能为空' }">
                          <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                            style="width: 70%; float: right" @change="getSkuList(item)" clearable>
                            <el-option v-for="item in productList" :key="item.key" :label="item.value1"
                              :value="item.key"> </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="SKU" class="channel_star"
                          v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'" prop="sku_id"
                          :rules="{ required: true, message: 'SKU不能为空' }">
                          <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                            style="width: 70%; float: right" clearable>
                            <el-option v-for="item in SkuList" :key="item.key" :label="item.value1" :value="item.key">
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="日期" class="channel_star"
                          v-if="item.array_date !== 'NONE' && item.array_date !== ''" prop="date_name"
                          :rules="{ required: true, message: '日期不能为空' }">
                          <el-date-picker v-model="item.addTableList.info_date" type="year"
                            style="width: 70%; float: right" format="yyyy年" value-format="yyyy年" placeholder="选择年"
                            v-if="item.array_date == 'YEAR'">
                          </el-date-picker>
                          <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                            :defaultValue="item.addTableList.info_date" :getValue="getQuarterValue"
                            style="width: 70%; float: right"></quarter>
                          <el-date-picker v-model="item.addTableList.info_date" type="month"
                            style="width: 70%; float: right" format="yyyy年MM月" value-format="yyyy年MM月" placeholder="选择月"
                            v-if="item.array_date == 'MONTH'">
                          </el-date-picker>
                          <monthComponent v-if="item.array_date == 'WEEK'" @week-event="parentWeekEvent"
                            :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                            style="width: 70%; float: right"></monthComponent>
                          <el-date-picker v-model="item.addTableList.info_date" type="date" placeholder="选择日期"
                            style="width: 70%; float: right" format="yyyy年MM月dd日" value-format="yyyy年MM月dd日"
                            v-if="item.array_date == 'DAY'">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="数值" prop="field_value" :rules="{ required: true, message: '数值不能为空' }">
                          <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                            style="width: 70%; float: right" type="number"></el-input>
                        </el-form-item>
                      </el-form>
                    </el-col>
                    <el-col :span="10">
                      <el-col style="margin-top: 20px">
                        <el-button size="small" style="
                            float: left;
                            margin-left: 40px;
                            background-color: #588ede;
                            border: 1px solid #588ede;
                            color: #fff;
                          " @click="addTableDataHcp(item)">保存
                        </el-button>
                        <el-button style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          " @click="delateTableData(item)" v-if="delateFalse" size="small">删除
                        </el-button>
                        <el-button size="small" style="
                            float: left;
                            margin-left: 20px;
                            background-color: #e87570;
                            border: 1px solid #e87570;
                            color: #fff;
                          " @click="cancelTableData(item)">取消
                        </el-button>
                      </el-col>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col span="24" v-else>
                  <el-form-item :label="item.label" :class="{ channel_star: item.mandatory == 'T' }" prop="field_value"
                    :rules="item.mandatory == 'T' ? [{ required: true, message: item.label + '不能为空' }] : []">
                    <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息" type="textarea"></el-input>
                  </el-form-item>
                </el-col>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <!--地图-->
    <el-dialog :visible.sync="showAmapDialog" :before-close="handleClose" :show-close="false" width="750px">
      <div slot="title" :class="$style.title">
        <span style="color: #3998f7; font-size: 16px">编辑坐标</span>
        <div>
          <el-col style="width: 128px; margin-top: -20px; float: right">
            <el-button type="primary" size="mini" @click.stop="handleSaveClick">保存</el-button>
            <el-button type="danger" size="mini" @click.stop="closeModal">取消</el-button>
          </el-col>
        </div>
      </div>
      <el-row style="border-top: 1px dashed #eded; position: relative; top: -13px">
        <el-col> </el-col>
      </el-row>

      <div class="amap-page-container" style="height: 400px">
        <el-amap-search-box :default="searchStr" class="search-box" :search-option="searchOption"
          :on-search-result="onSearchResult" style="position: relative; top: 20px; left: 20px"></el-amap-search-box>
        <el-amap vid="mapDemo3" :center="mapCenter" :zoom="12" class="amap-demo" :plugin="plugin"
          style="position: relative; top: -49px; margin: 0">
          <el-amap-marker :position="marker" :draggable="true" :events="edit_markers.events" v-for="marker in markers2">
          </el-amap-marker>
        </el-amap>
        <div align="center" style="width: 100%; margin-top: 10px">
          <span style="
              position: relative;
              top: -105px;
              background-color: #b6bbbf;
              border: 1px solid #ccc;
              color: #fff;
              font-size: 14px;
              border-radius: 5px;
              padding: 2px 5px;
            ">请拖拽地图上的图标进行修改</span>
        </div>
      </div>
      <div style="margin-top: 10px" class="amap">
        <el-form ref="formlist" :model="formlist" label-width="80px">
          <el-form-item label="地址">
            <!--<el-amap-search-box-->
            <!--class="search-box"-->
            <!--:search-option="searchOption"-->
            <!--:on-search-result="onSearchResult">-->
            <!--</el-amap-search-box>-->
            <el-input v-model="formlist.address"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!--机构报错信息-->
    <el-dialog :visible.sync="showModal2" :show-close="false" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal2 = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="Mechanism" stripe height="450px" style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75">
        </el-table-column>
        <el-table-column prop="distributor_code" label="经销商编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="distributor_name" label="经销商名称" min-width="150" sortable> </el-table-column>
        <el-table-column prop="distributor_type" label="类别" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="distributor_grade" label="级别" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="province_name" label="省份" min-width="150%" sortable> </el-table-column>
        <el-table-column prop="city_name" label="城市" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="address" label="地址" min-width="100%" sortable> </el-table-column>
        <el-table-column prop="telephone" label="联系电话" min-width="120" sortable> </el-table-column>
        <el-table-column prop="postcode" label="邮政编码" min-width="120" sortable> </el-table-column>
        <el-table-column prop="website" label="官方网址" min-width="120" sortable> </el-table-column>
        <el-table-column prop="comments" label="备注" min-width="120" sortable> </el-table-column>
        <el-table-column prop="status" label="是否启用" min-width="120" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!--坐标信息报错 -->
    <el-dialog id="travelSavePlanPs" :visible.sync="dialogLoaction" :show-close="false" width="900px"
      style="vertical-align: center">
      <div style="">
        <el-row style="margin-top: -30px">
          <el-col :span="12">
            <div style="color: #3998f7; padding-top: 8px; font-size: 20px">
              错误提示
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="primary" size="small" @click="handleExportData6">
                下载错误信息
              </el-button>
              <el-button type="danger" size="small" @click="dialogLoaction = false">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 20px">
        <el-table border :data="locationDate">
          <el-table-column fixed type="index" :index="1" label="序号" width="65px"></el-table-column>
          <el-table-column sortable property="distributor_code" label="经销商编码" width="150"></el-table-column>
          <el-table-column sortable property="distributor_name" label="经销商名称" width="200"></el-table-column>
          <el-table-column sortable property="location_code" label="位置编码" width="150"></el-table-column>
          <el-table-column sortable property="location_name" label="位置名称" width="200"></el-table-column>
          <el-table-column sortable property="address" label="地址"></el-table-column>
          <el-table-column sortable property="longitude" label="经度"></el-table-column>
          <el-table-column sortable property="latitude" label="纬度"></el-table-column>
          <el-table-column sortable property="status" label="是否启用"></el-table-column>
          <el-table-column fixed="right" width="250" sortable property="message" label="报错信息">
            <template slot-scope="scope">
              <div>
                <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!--店员报错信息-->
    <el-dialog :visible.sync="showModal3" :show-close="false" width="900px" style="margin-top: -20px">
      <div slot="title">
        <div slot="title" class="dialog-footer" style="display: flex; justify-content: space-between">
          <span style="color: #3998f7; font-size: 22px">错误提示</span>
          <span>
            <el-button type="primary" size="small" @click="handleExportData2">下载错误信息</el-button>
            <el-button type="danger" size="small" @click="showModal3 = false">关闭</el-button>
          </span>
        </div>
      </div>
      <el-table border :data="Mechanism2" stripe height="450px" style="width: 100%; margin-top: -20px"
        header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
        <el-table-column type="index" :index="1" label="序号" style="font-size: 20px; color: #585757" width="75">
        </el-table-column>
        <el-table-column prop="distributor_code" label="经销商编码" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="distributor_name" label="经销商名称" min-width="150" sortable> </el-table-column>
        <el-table-column prop="contact_code" label="客户编码" min-width="120" sortable> </el-table-column>
        <el-table-column prop="contact_name" label="客户姓名" min-width="120" sortable> </el-table-column>
        <el-table-column prop="department_name" label="所属部门" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="job_title" label="职务" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="gender" label="性别" min-width="120px" sortable> </el-table-column>
        <el-table-column prop="phone" label="联系电话" min-width="120" sortable> </el-table-column>
        <el-table-column prop="email" label="电子邮件" min-width="120" sortable> </el-table-column>
        <el-table-column prop="birthday" label="生日" min-width="120" sortable> </el-table-column>
        <el-table-column prop="hobby" label="爱好" min-width="120" sortable> </el-table-column>
        <el-table-column prop="status" label="是否在职" min-width="120" sortable> </el-table-column>
        <el-table-column fixed="right" label="报错信息" width="240px">
          <template slot-scope="scope">
            <div>
              <span style="font-size: 10px; color: red" v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  // import TreeNode from './components/treeNode'
  import http from "../../APIService/http";
  import quarter from "../../components/quarter";
  import monthComponent from "../../components/monthComponent";
  import http2 from "../../APIService/http2";
  import { bus } from "../../router/index.js";
  import tu1 from "../../assets/images/tu1.png";
  import tu2 from "../../assets/images/tu2.png";
  import { Message } from "element-ui";
  import { AMapManager } from "vue-amap";
  import imgUrl from "../../assets/images/mark_0.png";
  import xlsx from "xlsx";
  import { export_json_to_excel } from "../../vendor/Export2Excel";
  import { mapGetters, mapMutations } from "vuex";

  let amapManager = new AMapManager();
  export default {
    data() {
      const self = this;
      return {
        excelData: [],
        excelData2: [],
        excelData3: [],
        loadingText: "拼命加载中",
        record: [],
        errData: "",
        errData2: "",
        errData3: "",
        addTableList: {},
        delateFalse: false,
        tabIndex: 1,
        isAddTable: false,
        tableData: [],
        administrativeList: [],
        productList: [],
        SkuList: [],
        QUARTER: "",
        WEEK: "",
        contact_id: "",
        activeName1: "first",
        isfalse: false,
        dataList: [],
        retailStoreData_name: "",
        retailStoreData_location: "",
        retailStoreData_title: "",
        extendedInfo: [],
        extendedInfo1: [],
        activeName2: "first",
        centers: [],
        coordinatesList: [],
        isUpload3: false,
        dialogLoaction: false,
        locationDate: [],
        Mechanism3: [],
        arr3: [],
        fileList3: [],
        searchStr: "",
        dialog1: false,
        mydiv: 0,
        marginValue: "",
        widthLocation: "",
        formapLocation: {
          location_name: "",
          address: "",
          location_id: "",
          status: "INACTIVE",
          location_status: "ACTIVE",
        },
        locationInfo: [],
        Retailstore_id: "",
        file3: "",
        file2: "",
        file1: "",
        distributor_id: "",
        markers2: [],
        searchOption: {
          city: "上海",
          citylimit: false,
        },
        mapCenter: [121.59996, 31.197646],

        institutionStatus: true,
        institutionKey_acount: true,
        filterText: "",
        icon: [tu1, tu2],
        ContactList: {
          address: "",
          city_id: "",
          city_name: "",
          county_id: "",
          county_name: "",
          comments: "",
          distributor_grade: "",
          distributor_code: "",
          distributor_grade_name: "",
          distributor_id: "",
          distributor_name: "",
          distributor_type: "",
          distributor_type_name: "",
          lat: 0,
          lng: 0,
          location_id: "",
          postcode: "",
          province_id: "",
          province_name: "",
          telephone: "",
          tenant_id: "",
          website: "",
          account_level: "",
          account_level_name: "",
          account_verified: "F",
        },
        isDisabled: false,

        distributor_name: "",
        address: "",
        location_id: "",

        showAmapDialog: false,

        amapManager,
        zoom: 50,
        center: [116.46, 39.92],
        markers: [
          {
            position: [116.46, 39.92],
            events: {
              init(map) {
                AMapUI.loadUI(["overlay/SimpleMarker"], function (SimpleMarker) {
                  const marker = new SimpleMarker({
                    iconLabel: "A",
                    iconStyle: "red",
                    map: map,
                    position: map.getCenter(),
                  });
                });
              },
              click: () => {
                if (this.texts[0].name) {
                  this.texts[0].name = "";
                } else {
                  let name = "名称：" + self.storeInfoObj.store_name;
                  let address = "地址：" + self.storeInfoObj.address;

                  this.texts[0].name =
                    "<span style='font-size: 14px;margin: 5px'>" + name + "</span>" + "<br/>" + "<span style='font-size: 14px;margin: 5px'>" + address + "</span>" + "<br/>";

                  let userObj = this.$store.getters.getUser;
                  if (userObj.role === "admin") {
                    this.texts[0].name = this.texts[0].name + "<span style='color: #FF9901;font-size: 14px;margin: 5px;float: right;cursor:pointer'>编辑坐标</span>";
                  }
                }
              },
            },
            visible: true,
            template: "1",
          },
        ],
        edit_markers: {
          position: [],
          events: {
            dragend: (e) => {
              //拖拽结束

              this.getpois([e.lnglat.lng, e.lnglat.lat]);
              let geocoder;
              AMap.plugin("AMap.Geocoder", function () {
                // 这里通过高德 SDK 完成。
                geocoder = new AMap.Geocoder({
                  radius: 1000,
                  extensions: "all",
                });
              });

              geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function (status, result) {
                if (status === "complete" && result.info === "OK") {
                  if (result && result.regeocode) {
                    self.formapLocation.address = result.regeocode.formattedAddress; //获取到位置
                    self.formapLocation.location_name = result.regeocode.pois[0].name; //获取到位置
                  }
                }
              });
            },
          },
          visible: true,
        },
        texts: [
          {
            position: [116.46, 39.92],
            name: "",
            offset: [0, -65],
            events: {
              click: () => {
                let userObj = this.$store.getters.getUser;

                if (this.texts[0].name && userObj.role === "admin") {
                  self.showAmapDialog = true;
                }
              },
            },
          },
        ],
        plugin: [
          {
            pName: "ToolBar",
            position: "RB",
            locate: false,
            events: {
              init(instance) { },
            },
          },
        ],

        clerkClass: {
          department: "",
          birthday: "",
          contact_id: "",
          contact_name: "",
          distributor_id: "",
          email: "",
          gender: "",
          gender_name: "",
          hobby: "",
          job_title: "",
          job_title_name: "",
          pro_title_name: "",
          pro_title_id: "",
          mobile: "",
          status: true,
          status_name: "",
          tenant_id: "",
          contact_code: "",
        },
        clerkadd: {
          birthday: "",
          contact_name: "",
          distributor_id: "",
          email: "",
          gender: "",
          hobby: "",
          job_title: "",
          mobile: "",
          pro_title_id: "",
          status: true,
          contact_code: "",
          department: "",
        },
        fileList: [],
        fileList2: [],
        options: [],
        CityList: [],
        CountyList: [],
        file: "",
        loading: false,
        formlist: {
          address: "",
          city_id: "",
          city_name: "",
          county_id: "",
          county_name: "",
          comments: "",
          distributor_grade: "",
          distributor_grade_name: "",
          distributor_id: "",
          distributor_name: "",
          distributor_type: "",
          distributor_type_name: "",
          lat: 0,
          lng: 0,
          location_id: "",
          postcode: "",
          province_id: "",
          province_name: "",
          telephone: "",
          tenant_id: "",
          website: "",
          status: "",
          key_acount: "",
          distributor_code: "",
          agreement_stage: "",
          agreement_signed: true,
          account_level: "",
          account_verified: "F",
        },

        pushlist: {
          address: "",
          city_id: "",
          city_name: "",
          county_id: "",
          county_name: "",
          comments: "",
          distributor_grade: "",
          distributor_grade_name: "",
          distributor_id: "",
          distributor_name: "",
          distributor_type: "",
          distributor_type_name: "",
          lat: 0,
          lng: 0,
          location_id: "",
          postcode: "",
          province_id: "",
          province_name: "",
          telephone: "",
          tenant_id: "",
          website: "",
          status: true,
          key_acount: true,
          distributor_code: "",
          agreement_stage: "",
          agreement_signed: true,
          account_level: "",
          account_verified: "F",
        },
        form: {
          name: "1",
          title: "1",
          position: "1",
          input: "",
          input2: "",
        },

        input: "",
        prolist: [],
        jobtList: [],
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        dialogVisible5: false,
        dialogVisible6: false,
        activeName: "first",
        data: [],
        data2: [],
        province_id: "",
        city_id: "",
        county_id: "",
        city_lng: 0,
        city_lat: 0,
        defaultProps: {
          children: "children",
          label: "label",
        },
        value: true,
        listData: [],
        TypeList: [],
        GardeList: [],
        AccountLevelList: [],

        rules: {
          distributor_name: [{ required: true, message: "请输入名称" }],
          distributor_code: [{ required: true, message: "请输入经销商编码" }],
          distributor_type: [{ required: true, message: "请选择类别" }],
          //                    distributor_grade:[
          //                        {required: true,message: '请选择级别'}
          //                    ],
          province_id: [{ required: true, message: "请选择省份" }],

          city_id: [{ required: true, message: "请选择城市" }],
        },
        isUpload: false,
        isUpload2: false,
        Mechanism: [],
        arr: [],
        Mechanism2: [],
        arr2: [],
        showModal2: false,
        showModal3: false,
        Distributor: [],
        DistributorContact: [],
        AGREEMENT_STAGE: [],
        isDetail: false,
        isDetail1: false,
        tags: [],
        photoUrl: "",
        uuidAgenda: "",
        categoryAgenda: {},
        photoIdObj: {},
        photoIdArray: [],
        tagText: "",
        imgArray: [],
        photo_id_arr: [],
        editTags: [],
        type: "",
        selectPhotoId: "",
        fileDetail: false,
        fileInfo: {},
        fileTag: "",
        fileTags: [],
        fileTable: [],
        selectFileId: "",
        statistics: {},
        is_data: false,
      };
    },
    beforeDestroy() {
      amapManager.getMap().destroy();
    },
    async created() {
      // this.province_id = this.$route.query.province_id
      // this.city_id = this.$route.query.city_id
      // this.city_lng = this.$route.query.city_lng
      // this.city_lat = this.$route.query.city_lat
      this.province_id = this.cache_page("province_id");
      this.city_id = this.cache_page("city_id");
      this.county_id = this.cache_page("county_id");
      this.city_lng = this.cache_page("city_lng");
      this.city_lat = this.cache_page("city_lat");

      if (!this.province_id && !this.city_id) {
        this.province_id = "110000";
        this.city_id = "110100";
      }
      this.getProvinceAndCityList();
      this.getAccountList();

      this.getDistributorTypeList();
      this.getDictionaryListByKOL_LEVEL2();

      // this.getProvinceAndCityList1()
    },
    components: {
      quarter,
      monthComponent,
    },
    computed: {
      ...mapGetters({
        cache_page: "getMainCustomer",
      }),
    },
    watch: {
      province_id(val) {
        this.setMainCustomer({ province_id: val });
      },
      city_id(val) {
        this.setMainCustomer({ city_id: val });
      },
      county_id(val) {
        this.setMainCustomer({ county_id: val });
      },
      city_lng(val) {
        this.setMainCustomer({ city_lng: val });
      },
      city_lat(val) {
        this.setMainCustomer({ city_lat: val });
      },
      filterText(val) {
        this.$refs.tree.filter(val);
        this.$refs.tree2.filter(val);
      },
    },
    methods: {
      ...mapMutations(["setMainCustomer", "resetMainCustomer"]),
      getAdministrativeList() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          category: "STANDARD_DEPT",
        };
        http.post("/wapi/Institution/getAdministrativeList", data).then((res) => {
          if (res.success) {
            this.administrativeList = res.data;
          }
        });
      },

      getProductList() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        http.post("/wapi/Institution/getProductList", data).then((res) => {
          if (res.success) {
            this.productList = res.data;
          }
        });
      },
      getSkuList(item) {
        let product_id = "";
        if (item instanceof Object) {
          product_id = item.addTableList.product_id;
          item.addTableList.sku_id = "";
          item.addTableList.sku_name = "";
        } else {
          product_id = item;
        }

        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          product_id: product_id,
        };
        http.post("/wapi/Institution/getSkuList", data).then((res) => {
          if (res.success) {
            this.SkuList = res.data;
          }
        });
      },
      changeQUARTER(item) {
        this.QUARTER = "";
        var arr = item.split("-");
        if (arr[1] < 4) {
          this.QUARTER = arr[0] + "Q1";
        } else if (arr[1] > 3 && arr[1] < 7) {
          this.QUARTER = arr[0] + "Q2";
        } else if (arr[1] > 6 && arr[1] < 9) {
          this.QUARTER = arr[0] + "Q3";
        } else {
          this.QUARTER = arr[0] + "Q4";
        }

        console.log(item, this.QUARTER);
      },
      changeWEEK(item) {
        this.WEEK = "";
        var arr = item.split("-");
        if (arr[2] < 8) {
          this.WEEK = arr[0] + arr[1] + "W1";
        } else if (arr[2] > 7 && arr[2] < 15) {
          this.WEEK = arr[0] + arr[1] + "W2";
        } else if (arr[2] > 14 && arr[2] < 22) {
          this.WEEK = arr[0] + arr[1] + "W3";
        } else {
          this.WEEK = arr[0] + arr[1] + "W4";
        }
        console.log(item, this.WEEK);
      },
      getUuid() {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        return uuid;
      },
      delateTableData(item) {
        for (let i = 0; i < item.field_value.length; i++) {
          if (item.addTableList.id == item.field_value[i].id) {
            item.field_value.splice(i, 1);
            item.isAddTable = false;
            this.$forceUpdate();
          }
        }
      },
      addNewTable(item) {
        this.delateFalse = false;
        item.isAddTable = true;
        item.addTableList = {
          id: "",
          dept_id: "",
          dept_name: "",
          product_id: "",
          product_name: "",
          sku_id: "",
          sku_name: "",
          info_date: "",
          date_name: "",
          field_value: "",
        };
        this.addTableList = {};
        this.addTableList = item.addTableList;
        this.$forceUpdate();
      },
      addTableData(item) {
        this.$refs["addTable"][0].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER;
              let arr = this.QUARTER.split("Q");
              let year = arr[0].slice(0, 4);
              item.addTableList.date_name = `${year}年第${arr[1]}季度`;
            }
            if (this.WEEK) {
              item.addTableList.info_date = this.WEEK;
              let arr = this.WEEK.split("W");
              let year = arr[0].slice(0, 4);
              let month = arr[0].slice(4);
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
            }

            if (item.addTableList.id) {
              //编辑
              for (let i = 0; i < item.field_value.length; i++) {
                if (item.addTableList.id == item.field_value[i].id) {
                  item.field_value[i].dept_id = item.addTableList.dept_id;
                  if (item.addTableList.dept_id) {
                    for (let j = 0; j < this.administrativeList.length; j++) {
                      if (item.addTableList.dept_id == this.administrativeList[j].key) {
                        item.addTableList.dept_name = this.administrativeList[j].value1;
                        break;
                      }
                    }
                  }
                  item.field_value[i].dept_name = item.addTableList.dept_name;
                  item.field_value[i].product_id = item.addTableList.product_id;
                  if (item.addTableList.product_id) {
                    for (let j = 0; j < this.productList.length; j++) {
                      if (item.addTableList.product_id == this.productList[j].key) {
                        item.addTableList.product_name = this.productList[j].value1;
                        break;
                      }
                    }
                  }
                  item.field_value[i].product_name = item.addTableList.product_name;
                  item.field_value[i].sku_id = item.addTableList.sku_id;
                  if (item.addTableList.sku_id) {
                    for (let j = 0; j < this.SkuList.length; j++) {
                      if (item.addTableList.sku_id == this.SkuList[j].key) {
                        item.addTableList.sku_name = this.SkuList[j].value1;
                        break;
                      }
                    }
                  }
                  item.field_value[i].sku_name = item.addTableList.sku_name;
                  item.field_value[i].info_date = item.addTableList.info_date;
                  item.field_value[i].date_name = item.addTableList.date_name;
                  item.field_value[i].field_value = item.addTableList.field_value;
                }
              }
            } else {
              //新增
              item.addTableList.id = this.getUuid();
              if (item.addTableList.dept_id) {
                for (let i = 0; i < this.administrativeList.length; i++) {
                  if (item.addTableList.dept_id == this.administrativeList[i].key) {
                    item.addTableList.dept_name = this.administrativeList[i].value1;
                  }
                }
              }
              if (item.addTableList.product_id) {
                for (let i = 0; i < this.productList.length; i++) {
                  if (item.addTableList.product_id == this.productList[i].key) {
                    item.addTableList.product_name = this.productList[i].value1;
                  }
                }
              }
              if (item.addTableList.sku_id) {
                for (let i = 0; i < this.SkuList.length; i++) {
                  if (item.addTableList.sku_id == this.SkuList[i].key) {
                    item.addTableList.sku_name = this.SkuList[i].value1;
                  }
                }
              }
              if (this.QUARTER) {
                item.addTableList.info_date = this.QUARTER;
                let arr = this.QUARTER.split("Q");
                let year = arr[0].slice(0, 4);
                item.addTableList.date_name = `${year}年第${arr[1]}季度`;
              } else if (this.WEEK) {
                item.addTableList.info_date = this.WEEK;
                let arr = this.WEEK.split("W");
                let year = arr[0].slice(0, 4);
                let month = arr[0].slice(4);
                item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
              } else {
                item.addTableList.date_name = item.addTableList.info_date;
              }
              item.field_value.push(item.addTableList);
            }

            item.isAddTable = false;
            item.addTableList = {
              id: "",
              dept_id: "",
              dept_name: "",
              product_id: "",
              product_name: "",
              sku_id: "",
              sku_name: "",
              info_date: "",
              date_name: "",
              field_value: "",
            };
            this.$forceUpdate();
          }
        });
      },

      addTableDataHcp(item) {
        this.$refs["addTableHcp"][0].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            if (this.QUARTER) {
              item.addTableList.info_date = this.QUARTER;
              let arr = this.QUARTER.split("Q");
              let year = arr[0].slice(0, 4);
              item.addTableList.date_name = `${year}年第${arr[1]}季度`;
            }
            if (this.WEEK) {
              item.addTableList.info_date = this.WEEK;
              let arr = this.WEEK.split("W");
              let year = arr[0].slice(0, 4);
              let month = arr[0].slice(4);
              item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
            }

            if (item.addTableList.id) {
              //编辑
              for (let i = 0; i < item.field_value.length; i++) {
                if (item.addTableList.id == item.field_value[i].id) {
                  item.field_value[i].dept_id = item.addTableList.dept_id;
                  if (item.addTableList.dept_id) {
                    for (let j = 0; j < this.administrativeList.length; j++) {
                      if (item.addTableList.dept_id == this.administrativeList[j].key) {
                        item.addTableList.dept_name = this.administrativeList[j].value1;
                        break;
                      }
                    }
                  }
                  item.field_value[i].dept_name = item.addTableList.dept_name;
                  item.field_value[i].product_id = item.addTableList.product_id;
                  if (item.addTableList.product_id) {
                    for (let j = 0; j < this.productList.length; j++) {
                      if (item.addTableList.product_id == this.productList[j].key) {
                        item.addTableList.product_name = this.productList[j].value1;
                        break;
                      }
                    }
                  }
                  item.field_value[i].product_name = item.addTableList.product_name;
                  item.field_value[i].sku_id = item.addTableList.sku_id;
                  if (item.addTableList.sku_id) {
                    for (let j = 0; j < this.SkuList.length; j++) {
                      if (item.addTableList.sku_id == this.SkuList[j].key) {
                        item.addTableList.sku_name = this.SkuList[j].value1;
                        break;
                      }
                    }
                  }
                  item.field_value[i].sku_name = item.addTableList.sku_name;
                  item.field_value[i].info_date = item.addTableList.info_date;
                  item.field_value[i].date_name = item.addTableList.date_name;
                  item.field_value[i].field_value = item.addTableList.field_value;
                }
              }
            } else {
              //新增
              item.addTableList.id = this.getUuid();
              if (item.addTableList.dept_id) {
                for (let i = 0; i < this.administrativeList.length; i++) {
                  if (item.addTableList.dept_id == this.administrativeList[i].key) {
                    item.addTableList.dept_name = this.administrativeList[i].value1;
                  }
                }
              }
              if (item.addTableList.product_id) {
                for (let i = 0; i < this.productList.length; i++) {
                  if (item.addTableList.product_id == this.productList[i].key) {
                    item.addTableList.product_name = this.productList[i].value1;
                  }
                }
              }
              if (item.addTableList.sku_id) {
                for (let i = 0; i < this.SkuList.length; i++) {
                  if (item.addTableList.sku_id == this.SkuList[i].key) {
                    item.addTableList.sku_name = this.SkuList[i].value1;
                  }
                }
              }
              if (this.QUARTER) {
                item.addTableList.info_date = this.QUARTER;
                let arr = this.QUARTER.split("Q");
                let year = arr[0].slice(0, 4);
                item.addTableList.date_name = `${year}年第${arr[1]}季度`;
              } else if (this.WEEK) {
                item.addTableList.info_date = this.WEEK;
                let arr = this.WEEK.split("W");
                let year = arr[0].slice(0, 4);
                let month = arr[0].slice(4);
                item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`;
              } else {
                item.addTableList.date_name = item.addTableList.info_date;
              }
              item.field_value.push(item.addTableList);
            }

            item.isAddTable = false;
            item.addTableList = {
              id: "",
              dept_id: "",
              dept_name: "",
              product_id: "",
              product_name: "",
              sku_id: "",
              sku_name: "",
              info_date: "",
              date_name: "",
              field_value: "",
            };

            this.$forceUpdate();
          }
        });
      },
      cancelTableData(item) {
        item.isAddTable = false;
        item.addTableList = {
          id: "",
          dept_id: "",
          dept_name: "",
          product_id: "",
          product_name: "",
          sku_id: "",
          sku_name: "",
          info_date: "",
          date_name: "",
          field_value: "",
        };
        this.$forceUpdate();
      },
      handleClickTabs(tab, event) {
        this.tabIndex = tab.index;
      },
      parentEvent(data) {
        this.addTableList.info_date = data;
      },
      getQuarterValue(a, b) {
        this.QUARTER = a + "Q" + b;
      },
      getWeekValue(a, b, c) {
        let month = b.toString();
        this.WEEK = a + month + "W" + c;
        console.log(this.WEEK);
      },
      parentWeekEvent(data) {
        this.addTableList.info_date = data;
      },
      handleTableClick(index, row, item) {
        this.delateFalse = true;
        item.isAddTable = true;
        this.getSkuList(row.product_id);
        item.addTableList = {
          id: row.id,
          dept_id: row.dept_id,
          dept_name: row.dept_name,
          product_id: row.product_id,
          product_name: row.product_name,
          sku_id: row.sku_id,
          sku_name: row.sku_name,
          info_date: row.info_date,
          date_name: row.date_name,
          field_value: row.field_value,
        };
        this.$forceUpdate();
      },
      daoru() {
        (this.file = ""), (this.file2 = ""), (this.file3 = ""), (this.dialogVisible = true);
        this.form = {
          name: "1",
          position: "1",
          title: "1",
        };
        if (this.form.name == "") {
          this.retailStoreData_name = "经销商数据（全部省份）";
        }
        if (this.form.position == "") {
          this.retailStoreData_location = "经销商坐标数据（全部省份）";
        }
        if (this.form.title == "") {
          this.retailStoreData_title = "联系人数据（全部省份）";
        }
      },
      xiazai() {
        this.deriveDistributor();
      },
      xiazai2() {
        this.deriveDistributorContact();
      },
      async deriveDistributor() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          province_id: this.form.name,
        };
        let self = this;
        await http
          .post("/wapi/derive/deriveDistributor", data)
          .then((res) => {
            self.Distributor = res;
            this.handleExportData3();
          })
          .catch((err) => {
            Message({
              type: "error",
              message: "下载失败",
            });
          });
      },

      async deriveDistributorContact() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          province_id: this.form.name,
        };
        let self = this;
        await http
          .post("/wapi/derive/deriveDistributorContact", data)
          .then((res) => {
            self.DistributorContact = res;
            this.handleExportData4();
          })
          .catch((err) => {
            Message({
              type: "error",
              message: "下载失败",
            });
          });
      },

      closeModal2() {
        this.fileList = [];
        this.fileList2 = [];
        this.fileList3 = [];
        this.excelData = [];
        this.excelData2 = [];
        this.excelData3 = [];
        this.dialogVisible = false;
        this.isUpload = false;
        this.isUpload2 = false;
        this.isUpload3 = false;
      },
      async getParsingFile(fileName) {
        return new Promise(function (resolve, reject) {
          //定义reader，存放文件读取方法
          let reader = new FileReader();

          //启动函数
          reader.readAsBinaryString(fileName);
          //onload文件读取成功
          reader.onload = function (e) {
            //workbook存放excel的所有基本信息
            let workbook = xlsx.read(e.target.result, { type: "binary" });
            xlsx.onprogress = function (e) { };
            //定义sheetList中存放excel表格的sheet表，就是最下方的tab
            let sheetList = workbook.SheetNames;

            //存放json数组格式的表格数据
            let resultJson = [];
            if (sheetList.length > 1) {
              reject({ status: false, message: "模板错误,不能有1个以上sheet" });
            }
            sheetList.forEach(function (y) {
              let worksheet = workbook.Sheets[y];
              resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], {
                defval: "",
              });
            });

            if (resultJson.length === 0) {
              resolve({ status: true, data: resultJson });
            }
            //取出表头
            let tableHeader = Object.keys(resultJson[0]);

            //取出表数据
            let importInfo = resultJson.map((item) => {
              return tableHeader.map((v) => item[v]);
            });

            importInfo = [tableHeader, ...importInfo];
            resolve({ status: true, data: importInfo });
          };
          //文件读取失败
          reader.onerror = function (e) {
            reject({ status: false, message: "解析失败" });
          };
        });
      },
      async handleChange(file, fileList) {
        this.loading = true;
        this.$refs.upload.clearFiles();
        this.loadingText = "文件解析中";
        let res = await this.getParsingFile(file.raw);

        setTimeout(() => {
          this.loading = false;
          this.loadingText = "拼命加载中";
        }, 1000);
        if (!res.status) {
          this.$message.error(res.message);
          this.fileList = [];
          return;
        }

        if (res.data.length === 0 || res.data[0].length !== 14 || res.data[0][0].trim() !== "经销商编码") {
          this.$message.error("模板错误，请选择正确的模板");
          this.fileList = [];
          return false;
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error("导入数据必须大于0条");
          this.fileList = [];
          return false;
        }
        if (fileList.length !== 0 && res) {
          this.file = file.name;
        }
        this.excelData = res.data;
        //
        // this.file = file.name
        // const nameArr = file.name.split('.')
        // const extension = nameArr[nameArr.length-1] === 'xlsx'
        // const isLt2M = file.size / 1024 / 1024 < 10
        // if (!extension) {
        //     this.file = ''
        //     this.fileList = []
        //     Message({
        //         message: '上传模板只能是xlsx',
        //         type: 'error'
        //     })
        // }
        // if (!isLt2M) {
        //     this.file = ''
        //     this.fileList = []
        //     Message({
        //         message: '传模板大小不能超过 10MB',
        //         type: 'error'
        //     })
        // }
        // this.isUpload = true
        //
        // return extension && isLt2M
      },
      // handleChange(file, fileList) {
      //
      //   this.file = file.name
      //   const nameArr = file.name.split('.')
      //   const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //   const isLt2M = file.size / 1024 / 1024 < 10
      //   if (!extension) {
      //     this.file = ''
      //     this.fileList = []
      //     Message({
      //       message: '上传模板只能是xlsx',
      //       type: 'error'
      //     })
      //   }
      //   if (!isLt2M) {
      //     this.file = ''
      //     this.fileList = []
      //     Message({
      //       message: '传模板大小不能超过 10MB',
      //       type: 'error'
      //     })
      //   }
      //   this.isUpload = true
      //
      //   return extension && isLt2M
      // },
      async handleSuccess(res, file) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (res.success) {
          try {
            let data = {
              user_id: this.$store.getters.getUser.user_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              path: res.data,
            };

            await http.post("/wapi/excel/imortDistributor", data).then((res) => {
              loading.close();
              if (res.success) {
                this.closeModal2();

                if (res.data.length == 0) {
                  Message({
                    type: "success",
                    message: "导入成功",
                  });
                } else {
                  this.showModal2 = true;
                  this.Mechanism = [...res.data];
                  this.arr = [...res.data];
                }
              } else {
                this.fileList = [];

                Message({
                  type: "error",
                  message: "导入失败",
                });
              }

              this.loading = false;
            });
          } catch (err) {
            loading.close();
            Message.error("导入失败！");
          }
        } else {
          loading.close();
          Message.error("导入失败！");
        }
      },
      // imortDataClick() {
      //   if (this.isUpload) {
      //     this.$refs.upload.submit()
      //   } else {
      //     Message({
      //       message: '导入模板不能为空',
      //       type: 'error'
      //     })
      //   }
      // },
      async imortDataClick() {
        if (this.excelData.length === 0) {
          this.$message.error("请选择导入模板！");
          return false;
        }
        this.loading = true;
        this.loadingText = `正在导入数据0%(0/${this.excelData.length - 1})`;
        this.errData = "";
        this.record = [];
        let herder = this.excelData[0];
        let res = await this.importData(herder, this.excelData.slice(1), 0, 500, this.excelData.length - 1);

        if (!res) {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success("导入成功");
            this.loadingText = "拼命加载中";
            this.loading = false;
            if (this.errData.length > 0) {
              this.showModal2 = true;
              this.Mechanism = this.errData.slice(0, 100);
            }
          } else {
            this.$message.error("导入失败");
            this.loading = false;
            this.loadingText = "拼命加载中";
          }
        }
      },
      async importData(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true;
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          };

          let response = await http.post("/wapi/excel/imortDistributor", data);
          if (!response) {
            return false;
          }
          if (response.statusCode === 502) {
            return await this.importData(herder, excelData, page, limit, size);
          }
          this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
          this.loadingText += progressText;

          if (response.success) {
            this.record.push(true);
            if (response.data) {
              if (!this.errData) {
                this.errData = [];
              }
              this.errData = [...this.errData, ...response.data];
            }
          } else {
            this.record.push(false);
          }
          return await this.importData(herder, excelData, page + 1, limit, size);
        } catch (e) {
          return false;
        }
      },
      // handleChange2(file, fileList) {
      //
      //   this.file3 = file.name
      //   const nameArr = file.name.split('.')
      //   const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //   const isLt2M = file.size / 1024 / 1024 < 10
      //   if (!extension) {
      //     this.file = ''
      //     this.fileList2 = []
      //     Message({
      //       message: '上传模板只能是xlsx',
      //       type: 'error'
      //     })
      //   }
      //   if (!isLt2M) {
      //     this.file = ''
      //     this.fileList2 = []
      //     Message({
      //       message: '传模板大小不能超过 10MB',
      //       type: 'error'
      //     })
      //   }
      //   this.isUpload2 = true
      //
      //   return extension && isLt2M
      // },
      async handleChange2(file, fileList) {
        this.loading = true;
        this.$refs.upload2.clearFiles();
        this.loadingText = "文件解析中";
        let res = await this.getParsingFile(file.raw);

        setTimeout(() => {
          this.loading = false;
          this.loadingText = "拼命加载中";
        }, 1000);
        if (!res.status) {
          this.$message.error(res.message);
          this.fileList2 = [];
          return;
        }

        if (res.data.length === 0 || res.data[0].length !== 12 || res.data[0][0].trim() !== "经销商编码") {
          this.$message.error("模板错误，请选择正确的模板");
          this.fileList2 = [];
          return false;
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error("导入数据必须大于0条");
          this.fileList2 = [];
          return false;
        }
        if (fileList.length !== 0 && res) {
          this.file3 = file.name;
        }
        this.excelData2 = res.data;
        //
        // this.file3 = file.name
        // const nameArr = file.name.split('.')
        // const extension = nameArr[nameArr.length-1] === 'xlsx'
        // const isLt2M = file.size / 1024 / 1024 < 10
        // if (!extension) {
        //     this.file = ''
        //     this.fileList2 = []
        //     Message({
        //         message: '上传模板只能是xlsx',
        //         type: 'error'
        //     })
        // }
        // if (!isLt2M) {
        //     this.file = ''
        //     this.fileList2 = []
        //     Message({
        //         message: '传模板大小不能超过 10MB',
        //         type: 'error'
        //     })
        // }
        // this.isUpload2 = true
        //
        // return extension && isLt2M
      },

      async handleSuccess2(res, file) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (res.success) {
          try {
            //                        var user = this.$store.getters.getUser

            let data = {
              user_id: this.$store.getters.getUser.user_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              path: res.data,
            };

            await http.post("/wapi/excel/imortDistributorContact", data).then((res) => {
              loading.close();
              if (res.success) {
                this.closeModal2();
                if (res.data.length == 0) {
                  Message({
                    type: "success",
                    message: "导入成功",
                  });
                } else {
                  this.showModal3 = true;
                  this.Mechanism2 = [...res.data];
                  this.arr2 = [...res.data];
                }
              } else {
                this.fileList2 = [];

                Message({
                  type: "error",
                  message: "导入失败",
                });
              }

              this.loading = false;
            });
          } catch (err) {
            loading.close();
            Message.error("导入失败！");
          }
        } else {
          loading.close();
          Message.error("导入失败！");
        }
      },
      // imortDataClick2() {
      //   if (this.isUpload2) {
      //     this.$refs.upload2.submit()
      //   } else {
      //     Message({
      //       showClose: true,
      //       message: '导入模板不能为空',
      //       type: 'error'
      //     })
      //   }
      // },
      async imortDataClick2() {
        if (this.excelData2.length === 0) {
          this.$message.error("请选择导入模板！");
          return false;
        }
        this.loading = true;
        this.loadingText = `正在导入数据0%(0/${this.excelData2.length - 1})`;
        this.errData2 = "";
        this.record = [];
        let herder = this.excelData2[0];
        let res = await this.importData2(herder, this.excelData2.slice(1), 0, 500, this.excelData2.length - 1);

        if (!res) {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success("导入成功");
            this.loadingText = "拼命加载中";
            this.loading = false;
            if (this.errData2.length > 0) {
              this.showModal3 = true;
              this.Mechanism2 = this.errData2.slice(0, 100);
            }
          } else {
            this.$message.error("导入失败");
            this.loading = false;
            this.loadingText = "拼命加载中";
          }
        }
        // if (this.isUpload2) {
        //     this.$refs.upload2.submit()
        // } else {
        //     Message({
        //         showClose: true,
        //         message: '导入模板不能为空',
        //         type: 'error'
        //     })
        // }
      },
      async importData2(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true;
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          };

          let response = await http.post("/wapi/excel/imortDistributorContact", data);
          if (!response) {
            return false;
          }
          if (response.statusCode === 502) {
            return await this.importData2(herder, excelData, page, limit, size);
          }
          this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
          this.loadingText += progressText;

          if (response.success) {
            this.record.push(true);
            if (response.data) {
              if (!this.errData2) {
                this.errData2 = [];
              }
              this.errData2 = [...this.errData2, ...response.data];
            }
          } else {
            this.record.push(false);
          }
          return await this.importData2(herder, excelData, page + 1, limit, size);
        } catch (e) {
          return false;
        }
      },
      obj_to_arr(names, data) {
        return data.map((item) => {
          let arr = [];
          names.forEach((name) => {
            arr.push(item[name]);
          });
          return arr;
        });
      },
      downloadErrorExcel(header, data, page = 0, limit = 5000) {
        try {
          if (page * limit >= data.length) {
            return true;
          }

          //错误数据
          let tHeader = header;
          let tData = data.slice(page * limit, (page + 1) * limit);
          export_json_to_excel({
            header: tHeader,
            data: tData,
            filename: "错误信息" + (!page ? "" : page),
          });
          this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`;
          this.downloadErrorExcel(header, data, page + 1, limit);
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
      },
      handleExportData() {
        try {
          this.loading = true;

          let tHeader = ["经销商编码", "经销商名称", "类别", "级别", "省份", "城市","区县", "地址", "联系电话", "邮政编码", "官方网址", "备注", "是否启用","是否重点客户", "报错信息"];

          let names = [
            "distributor_code",
            "distributor_name",
            "distributor_type",
            "distributor_grade",
            "province_name",
            "city_name",
            "county_name",
            "address",
            "telephone",
            "postcode",
            "website",
            "comments",
            "status",
            "key_acount",
            "message",
          ];
          let data = this.obj_to_arr(names, this.errData);
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`;
          this.downloadErrorExcel(tHeader, data, 0, 20000);
          //错误数据
          this.loading = false;
          this.loadingText = "拼命加载中";
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
      },

      // handleExportData() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['机构编码', '机构名称', '类别', '级别', '省份', '城市', '地址', '联系电话', '邮政编码', '官方网址', '备注', '报错信息']
      //       const filterVal = [
      //         'distributor_code',
      //         'distributor_name',
      //         'distributor_type',
      //         'distributor_grade',
      //         'province_id',
      //         'city_id',
      //         'address',
      //         'telephone',
      //         'postcode',
      //         'website',
      //         'comments',
      //         'message'
      //       ]
      //       let arr = [...this.arr]
      //       for (var i = 0; i < arr.length; i++) {
      //         let obj = arr[i].message.join(" ")
      //         arr[i].message = obj
      //       }
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.showModal2 = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },
      handleExportData2() {
        try {
          this.loading = true;
          let tHeader = ["经销商编码", "经销商名称", "联系人编码", "联系人姓名", "所属部门", "职务", "性别", "联系电话", "电子邮件", "生日", "爱好", "是否在职", "报错信息"];
          let names = [
            "distributor_code",
            "distributor_name",
            "contact_code",
            "contact_name",
            "department_name",
            "job_title",
            "gender",
            "phone",
            "email",
            "birthday",
            "hobby",
            "status",
            "message",
          ];
          let data = this.obj_to_arr(names, this.errData2);
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`;
          this.downloadErrorExcel(tHeader, data, 0, 20000);
          //错误数据
          this.loading = false;
          this.loadingText = "拼命加载中";
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
      },

      // handleExportData2() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['机构编码', '机构名称', '客户编码', '客户姓名', '性别', '联系电话', '电子邮件', '生日', '爱好', '报错信息'
      //       ]
      //       const filterVal = [
      //         'store_code',
      //         'store_name',
      //         'clerk_code',
      //         'clerk_name',
      //         'gender',
      //         'phone',
      //         'email',
      //         'birthday',
      //         'hobby',
      //         'message',
      //       ]
      //       let arr = [...this.arr2]
      //       for (var i = 0; i < arr.length; i++) {
      //         let obj = arr[i].message.join(" ")
      //         arr[i].message = obj
      //       }
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.showModal3 = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },

      handleExportData3() {
        try {
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          //                    this.Distributor=[]
          import("@/vendor/Export2Excel").then((excel) => {
            const tHeader = ["经销商编码", "经销商名称", "类别", "级别", "省份", "城市","区县", "地址", "联系电话", "邮政编码", "官方网址", "备注", "是否启用", "是否重点客户"];
            const filterVal = [
              "distributor_code",
              "distributor_name",
              "distributor_type",
              "distributor_grade",
              "province_name",
              "city_name",
              "county_name",
              "address",
              "telephone",
              "postcode",
              "website",
              "comments",
              "status",
              "key_acount",
            ];

            const list = this.Distributor;
            const data = this.formatJson(filterVal, list);

            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.retailStoreData_name,
              autoWidth: this.autoWidth,
            });
          });
          loading.close();
          this.showModal2 = false;
        } catch (err) {
          loading.close();
          this.error();
        }
      },

      handleExportData4() {
        try {
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          //                    this.DistributorContact=[]
          import("@/vendor/Export2Excel").then((excel) => {
            const tHeader = ["经销商编码", "经销商名称", "联系人编码", "联系人姓名", "所属部门", "担任职务", "性别", "联系电话", "电子邮件", "生日", "爱好", "是否在职"];
            const filterVal = [
              "distributor_code",
              "distributor_name",
              "contact_code",
              "contact_name",
              "department",
              "job_title",
              "gender",
              "phone",
              "email",
              "birthday",
              "hobby",
              "status",
            ];

            const list = this.DistributorContact;
            const data = this.formatJson(filterVal, list);

            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.retailStoreData_title,
              autoWidth: this.autoWidth,
            });
          });
          loading.close();
        } catch (err) {
          loading.close();
          this.error();
        }
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map((v) => filterVal.map((j) => v[j]));
      },

      async search(queryString, cb) {
        if (queryString) {
          try {
            this.filterText = queryString.trim();

            let data = {
              tenant_id: this.$store.getters.getUser.tenant_id,
              search: queryString.trim(),
              // province_id: this.province_id,
            };
            await http.post("/wapi/Distributor/searchDistributorList", data).then((res) => {
              if (res.success) {
                cb(res.data);
              } else {
                Message.error(res.message);
              }
            });
          } catch (err) {
            console.log(`error:${err}`);
          }
        } else {
          cb([]);
        }
      },
      handleSelect(item) {
        this.filterText = item.distributor_name;
        this.distributor_id = item.distributor_id;
        this.activeName2 = "first";
        this.province_id = item.province_id;
        this.city_id = item.city_id;
        this.county_id = item.county_id;
        this.getDistributorInfoAction();
        this.getExtendedInfo();

        this.getDistributorContactList();
        this.getProList();
        this.getJobtList();

        //
      },

      async getDistributorInfoAction() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.distributor_id,
        };
        let self = this;
        await http.post("/wapi/Distributor/getDistributorInfo", data).then((res) => {
          if (res.success) {
            this.is_data = true;
            self.ContactList.address = res.data[0].address;
            self.ContactList.distributor_code = res.data[0].distributor_code;
            self.ContactList.city_id = res.data[0].city_id;
            self.ContactList.city_name = res.data[0].city_name;
            self.ContactList.county_id = res.data[0].county_id;
            self.ContactList.county_name = res.data[0].county_name;
            self.ContactList.comments = res.data[0].comments;
            self.ContactList.distributor_grade = res.data[0].distributor_grade;
            self.ContactList.distributor_grade_name = res.data[0].distributor_grade_name;
            self.ContactList.distributor_id = res.data[0].distributor_id;
            self.ContactList.distributor_name = res.data[0].distributor_name;
            self.ContactList.distributor_type = res.data[0].distributor_type;
            self.ContactList.distributor_type_name = res.data[0].distributor_type_name;
            self.ContactList.lat = res.data[0].lat;
            self.ContactList.lng = res.data[0].lng;
            self.ContactList.location_id = res.data[0].location_id;
            self.ContactList.postcode = res.data[0].postcode;
            self.ContactList.province_id = res.data[0].province_id;
            self.ContactList.province_name = res.data[0].province_name;
            self.ContactList.telephone = res.data[0].telephone;
            self.ContactList.tenant_id = res.data[0].tenant_id;
            self.ContactList.website = res.data[0].website;
            self.ContactList.account_level = res.data[0].account_level;
            self.ContactList.account_level_name = res.data[0].account_level_name;
            self.ContactList.account_verified = res.data[0].account_verified;
            this.Retailstore_id = res.data[0].distributor_id;
            this.getLocation();
            self.formlist.address = res.data[0].address;
            self.formlist.city_id = res.data[0].city_id;
            self.formlist.city_name = res.data[0].city_name;
            self.formlist.county_id = res.data[0].county_id;
            self.formlist.county_name = res.data[0].county_name;
            self.formlist.comments = res.data[0].comments;
            self.formlist.distributor_grade = res.data[0].distributor_grade;
            self.formlist.distributor_grade_name = res.data[0].distributor_grade_name;
            self.formlist.distributor_id = res.data[0].distributor_id;
            self.formlist.distributor_name = res.data[0].distributor_name;
            self.formlist.distributor_type = res.data[0].distributor_type;
            self.formlist.distributor_type_name = res.data[0].distributor_type_name;
            self.formlist.lat = res.data[0].lat;
            self.formlist.lng = res.data[0].lng;
            self.formlist.location_id = res.data[0].location_id;
            self.formlist.postcode = res.data[0].postcode;
            self.formlist.province_id = res.data[0].province_id;
            self.formlist.province_name = res.data[0].province_name;
            self.formlist.telephone = res.data[0].telephone;
            self.formlist.tenant_id = res.data[0].tenant_id;
            self.formlist.website = res.data[0].website;
            self.formlist.distributor_code = res.data[0].distributor_code;
            self.formlist.account_level = res.data[0].account_level;
            self.formlist.account_verified = res.data[0].account_verified;

            self.distributor_name = res.data[0].distributor_name;
            self.address = res.data[0].address;
            self.location_id = res.data[0].location_id;

            if (res.data[0].status == "ACTIVE") {
              self.formlist.status = true;
            } else {
              self.formlist.status = false;
            }

            if (res.data[0].status == "ACTIVE") {
              this.institutionStatus = true;
            } else {
              this.institutionStatus = false;
            }

            if (res.data[0].key_acount == "T") {
              self.formlist.key_acount = true;
            } else {
              self.formlist.key_acount = false;
            }

            if (res.data[0].key_acount == "T") {
              this.institutionKey_acount = true;
            } else {
              this.institutionKey_acount = false;
            }

            this.center = [res.data[0].lng, res.data[0].lat];

            let xiabiaoshenfen = 0;
            let xiabiaochengshi = 0;

            for (var i = 0; i < this.data.length; i++) {
              let obj = this.data[i];
              if (obj.id == res.data[0].province_id) {
                this.province_id = obj.id;
                xiabiaoshenfen = i;
                for (var j = 0; j < obj.children.length; j++) {
                  let obj2 = obj.children[j];
                  if (obj2.id == res.data[0].city_id) {
                    this.city_id = obj2.id;

                    xiabiaochengshi = j;
                  }
                }
              }
            }
            this.$nextTick(() => {
              // treeBox 元素的ref   value 绑定的node-key
              this.$refs.tree.setCurrentKey(this.city_id);
              this.getDistributorListAcion();
              //
            });
          } else {
            Message.error(res.message);
          }
        });
      },

      async getDistributorListAcion() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          // province_id:this.province_id,
          city_id: this.city_id,
        };
        let self = this;
        await http.post("/wapi/Distributor/getDistributorList", data).then((res) => {
          if (res.success) {
            self.data2 = res.data;
            this.$nextTick(() => {
              // treeBox 元素的ref   value 绑定的node-key
              this.$refs.tree2.setCurrentKey(this.distributor_id);
            });
          } else {
            Message.error(res.message);
          }
        });
      },
      onSearchResult(pois) {
        let latSum = 0;
        let lngSum = 0;
        this.formapLocation.address = pois[0].address; //获取到位置
        this.formapLocation.location_name = pois[0].name; //获取到位置
        if (pois.length > 0) {
          this.markers2 = [];
          this.edit_markers.position = [];
          //                    pois.forEach(poi => {
          let { lng, lat } = pois[0];
          lngSum += lng;
          latSum += lat;
          this.markers2.push([pois[0].lng, pois[0].lat]);
          this.edit_markers.position = [pois[0].lng, pois[0].lat];

          //                    });
          let center = {
            lng: lngSum, /// pois.length,
            lat: latSum, /// pois.length
          };
          this.mapCenter = [center.lng, center.lat];
          Message({
            type: "success",
            message: "坐标已选取",
          });
        }
      },
      showAmapDialogAction() {
        this.searchStr = "";
        this.showAmapDialog = true;
        this.markers2 = [];
        this.markers2.push([this.formlist.lng, this.formlist.lat]);
        let center = {
          lng: this.formlist.lng,
          lat: this.formlist.lat,
        };
        if (parseInt(this.formlist.lng) + parseInt(this.formlist.lat) == 0) {
          this.searchStr = this.formlist.address;
        }
        this.mapCenter = [center.lng, center.lat];
      },
      tianjia() {
        this.clerkadd = {
          birthday: "",
          contact_name: "",
          distributor_id: "",
          email: "",
          gender: "",
          hobby: "",
          job_title_id: "",
          mobile: "",
          pro_title_id: "",
          status: true,
          contact_code: "",
        };
        this.dialogVisible6 = true;
        this.$refs["clerkadd"].resetFields();
      },
      xinzeng() {
        this.pushlist = {
          address: "",
          city_id: "",
          city_name: "",
          county_id: "",
          county_name: "",
          comments: "",
          distributor_grade: "",
          distributor_grade_name: "",
          distributor_id: "",
          distributor_name: "",
          distributor_type: "",
          distributor_type_name: "",
          lat: 0,
          lng: 0,
          location_id: "",
          postcode: "",
          province_id: "",
          province_name: "",
          telephone: "",
          tenant_id: "",
          website: "",
          status: true,
          agreement_stage: "",
          agreement_signed: true,
          account_level: "",
          account_verified: "F",
        };
        this.CityList = [];
        this.CountyList = [];
        this.GardeList = [];
        this.dialogVisible5 = true;
        this.$refs["pushlist"].resetFields();

        // this.getDistributorGardeList(this.formlist.distributor_type);
      },
      handleClose() { },
      handleSaveClick() {
        this.setDistributorLocation();
        this.showAmapDialog = false;
      },
      closeModal() {
        this.showAmapDialog = false;
      },
      baocun4() {
        this.$refs["pushlist"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.addDistributor();
          }
        });
      },
      quxiao() {
        this.dialogVisible5 = false;
        this.$refs["pushlist"].resetFields();
      },
      quxiao2() {
        this.dialogVisible6 = false;
        this.clerkadd = {};
      },
      baocun3() {
        if (this.activeName2 == "first") {
          this.$refs["formlist"].validate((valid) => {
            if (!valid) {
              return false;
            } else {
              this.updateDistributor();
            }
          });
        } else {
          let off = true;
          if (this.extendedInfo[this.tabIndex - 1].fieldArray.length > 0) {
            for (var i = 0; i < this.extendedInfo[this.tabIndex - 1].fieldArray.length; i++) {
              if (this.extendedInfo[this.tabIndex - 1].fieldArray[i].mandatory == "T") {
                this.$refs["list" + i][0].validate((valid) => {
                  if (!valid) {
                    off = false;
                  }
                });
              }
            }
            if (off) {
              this.updateExtendedInfo();
            }
          }
        }
      },

      setInstitutionStatusBySwitch(status) {
        this.setDistributorStatus(status);
      },
      baocun2() {
        this.$refs["clerkadd"].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            this.addDistributorContact();
            this.dialogVisible6 = false;
          }
        });
      },
      baocun() {
        if (this.activeName1 == "first") {
          this.$refs["clerkClass"].validate((valid) => {
            if (!valid) {
              return false;
            } else {
              this.updateDistributorContact();
            }
          });
        } else {
          let off = true;
          if (this.extendedInfo1[this.tabIndex - 1].fieldArray.length > 0) {
            for (var i = 0; i < this.extendedInfo1[this.tabIndex - 1].fieldArray.length; i++) {
              if (this.extendedInfo1[this.tabIndex - 1].fieldArray[i].mandatory == "T") {
                this.$refs["contactList" + i][0].validate((valid) => {
                  if (!valid) {
                    off = false;
                  }
                });
              }
            }
            if (off) {
              this.updateContactExtendedInfo();
            }
          }
        }
      },
      concate() {
        this.dialogVisible3 = false;
        this.extendedInfo1 = [];
      },
      handleEdit(index, row) {
        this.getAdministrativeList();
        this.getProductList();
        this.dialogVisible3 = true;
        this.activeName1 = "first";
        this.contact_id = row.contact_id;
        this.getContactExtendedInfo();

        this.clerkClass.department = row.department;
        this.clerkClass.distributor_id = row.distributor_id;
        this.clerkClass.contact_name = row.contact_name;
        this.clerkClass.contact_code = row.contact_code;
        this.clerkClass.gender = row.gender;
        this.clerkClass.hobby = row.hobby;
        this.clerkClass.job_title_name = row.job_title_name;
        this.clerkClass.mobile = row.mobile;
        this.clerkClass.pro_title_name = row.pro_title_name;
        this.clerkClass.birthday = row.birthday;
        this.clerkClass.contact_id = row.contact_id;
        this.clerkClass.email = row.email;
        this.clerkClass.gender_name = row.gender_name;
        this.clerkClass.job_title = row.job_title;
        this.clerkClass.pro_title_id = row.pro_title_id;
        this.clerkClass.status_name = row.status_name;
        if (row.status == "ACTIVE") {
          this.clerkClass.status = true;
        } else {
          this.clerkClass.status = false;
        }
        this.clerkClass.tenant_id = row.tenant_id;
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },

      handleNodeClick(data, node) {
        if (node.level === 1) {
          this.city_id = "";
          this.province_id = data.id;
          if (data.children.length > 0) {
            this.getDistributorList();
          } else {
            this.data2 = [];
            this.is_data = false;
          }
          // this.getCityList(data.id)
        } else {
          this.province_id = data.province_id;
          this.city_id = data.city_id;
          this.county_id = data.county_id;
          this.city_lng = data.lng;
          this.city_lat = data.lat;
          this.getDistributorList();
        }
      },

      handleNodeClick2(data) {
        this.distributor_id = data.id;
        this.mydiv = 0;
        this.marginValue = 0;
        this.activeName2 = "first";
        if (!this.city_id) {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(data.city_id);
          });
        }
        this.getDistributorInfo();
        this.getDistributorContactList();
        this.getProList();
        this.getJobtList();
        this.getExtendedInfo();
      },
      handleClick(tab, event) { },
      addlist() {
        var oDiv = document.getElementById("div1");
        if (oDiv.style.display == "block") {
          oDiv.style.display = "none";
        } else {
          oDiv.style.display = "block";
          this.isDisabled = true;
        }
      },
      closelist() {
        var oDiv = document.getElementById("div1");
        if (oDiv.style.display == "block") {
          oDiv.style.display = "none";
          this.isDisabled = false;
        } else {
          oDiv.style.display = "block";
        }
      },

      dianji() {
        this.$router.push({ path: "/clients/staffMap" });
        // window.location.reload();
      },
      dianji1() {
        this.$router.push({ path: "/clients/index" });
        // window.location.reload();
      },
      dianji2() {
        this.$router.push({ path: "/clients/retail" });
        // window.location.reload();
      },
      async getProvinceAndCityList() {
        this.loading = true;
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          // province_id:this.province_id
        };
        let self = this;
        await http.post("/wapi/Province/getProvinceAndCityList", data).then((res) => {
          this.loading = false;
          if (res.success) {
            self.data = res.data;
            if (!parseFloat(this.city_lng)) {
              this.city_lng = res.data[0].children[0].lng;
              this.city_lat = res.data[0].children[0].lat;
            }
            if (!this.city_id) {
              let city = res.data.filter((v) => v.id === this.province_id)[0].children[0];
              if (city) {
                this.city_id = city.id;
                this.$nextTick(() => {
                  this.$refs.tree.setCurrentKey(city.id);
                });
              } else {
                this.$nextTick(() => {
                  this.$refs.tree.setCurrentKey(this.province_id);
                });
              }
            }

            this.dataList = JSON.parse(JSON.stringify(res.data));
            this.dataList.unshift({
              id: "1",
              label: "全部省份",
            });
            this.getDistributorList();
            this.getCityList(this.province_id);
          } else {
            Message.error(res.message);
            this.loading = false;
          }
        });
      },

      async getProvinceAndCityList1() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        await http.post("/wapi/Province/getProvinceAndCityList", data).then((res) => {
          if (res.success) {
            this.dataList = res.data;
            this.dataList.unshift({
              id: "1",
              label: "全部省份",
            });
          } else {
            Message.error(res.message);
          }
        });
      },

      async getDistributorList(type) {
        this.loading = true;
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          province_id: this.province_id,
          city_id: this.city_id,
        };
        let self = this;
        await http.post("/wapi/Distributor/getDistributorList", data).then((res) => {
          if (res.success) {
            self.data2 = res.data;
            if (res.data.length > 0) {
              if (type !== "edit") {
                self.distributor_id = res.data[0].id;
              }
              if (!data.city_id) {
                this.$nextTick(() => {
                  this.$refs.tree.setCurrentKey(res.data[0].city_id);
                });
              }
              this.getDistributorInfo2(self.distributor_id);
              this.getExtendedInfo();
            }
            this.is_data = false;
            this.loading = false;
          } else {
            this.loading = false;
            Message.error(res.message);
          }
        });
      },
      async getDistributorInfo2(distributor_id) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: distributor_id,
        };
        let self = this;
        await http.post("/wapi/Distributor/getDistributorInfo", data).then((res) => {
          if (res.success) {
            this.is_data = true;
            self.distributor_id = res.data[0].distributor_id;

            self.$nextTick(() => {
              // treeBox 元素的ref   value 绑定的node-key
              self.$refs.tree2.setCurrentKey(self.distributor_id);

              let num = 0;
              for (let i = 0; i < this.data2.length; i++) {
                if (this.data2[i].id === self.distributor_id) {
                  num = i;
                  break;
                }
              }

              let top = 40 * num;
              let constrution_tree = document.querySelectorAll(".constrution-tree2");
              constrution_tree[0].scrollTop = top;
            });
            self.ContactList.address = res.data[0].address;
            self.ContactList.city_id = res.data[0].city_id;
            self.ContactList.city_name = res.data[0].city_name;
            self.ContactList.county_id = res.data[0].county_id;
            self.ContactList.county_name = res.data[0].county_name;
            self.ContactList.comments = res.data[0].comments;
            self.ContactList.distributor_grade = res.data[0].distributor_grade;
            self.ContactList.distributor_grade_name = res.data[0].distributor_grade_name;
            self.ContactList.distributor_id = res.data[0].distributor_id;
            self.ContactList.distributor_name = res.data[0].distributor_name;
            self.ContactList.distributor_type = res.data[0].distributor_type;
            self.ContactList.distributor_type_name = res.data[0].distributor_type_name;
            self.ContactList.lat = res.data[0].lat;
            self.ContactList.lng = res.data[0].lng;
            self.ContactList.location_id = res.data[0].location_id;
            self.ContactList.postcode = res.data[0].postcode;
            self.ContactList.province_id = res.data[0].province_id;
            self.ContactList.province_name = res.data[0].province_name;
            self.ContactList.telephone = res.data[0].telephone;
            self.ContactList.tenant_id = res.data[0].tenant_id;
            self.ContactList.website = res.data[0].website;
            self.ContactList.distributor_code = res.data[0].distributor_code;
            self.ContactList.account_level = res.data[0].account_level;
            self.ContactList.account_level_name = res.data[0].account_level_name;
            self.ContactList.account_verified = res.data[0].account_verified;
            this.Retailstore_id = this.distributor_id;
            this.getLocation();

            self.formlist.address = res.data[0].address;
            self.formlist.city_id = res.data[0].city_id;
            self.formlist.city_name = res.data[0].city_name;
            self.formlist.county_id = res.data[0].county_id;
            self.formlist.county_name = res.data[0].county_name;
            self.formlist.comments = res.data[0].comments;
            self.formlist.distributor_grade = res.data[0].distributor_grade;
            self.formlist.distributor_grade_name = res.data[0].distributor_grade_name;
            self.formlist.distributor_id = res.data[0].distributor_id;
            self.formlist.distributor_name = res.data[0].distributor_name;
            self.formlist.distributor_type = res.data[0].distributor_type;
            self.formlist.distributor_type_name = res.data[0].distributor_type_name;
            self.formlist.lat = res.data[0].lat;
            self.formlist.lng = res.data[0].lng;
            self.formlist.location_id = res.data[0].location_id;
            self.formlist.postcode = res.data[0].postcode;
            self.formlist.province_id = res.data[0].province_id;
            self.formlist.province_name = res.data[0].province_name;
            self.formlist.telephone = res.data[0].telephone;
            self.formlist.tenant_id = res.data[0].tenant_id;
            self.formlist.website = res.data[0].website;
            self.formlist.distributor_code = res.data[0].distributor_code;
            self.formlist.distributor_grade_name = res.data[0].distributor_grade_name;
            self.formlist.agreement_stage = res.data[0].agreement_stage;
            self.formlist.account_level = res.data[0].account_level;
            self.formlist.account_verified = res.data[0].account_verified;

            self.distributor_name = res.data[0].distributor_name;
            self.address = res.data[0].address;
            self.location_id = res.data[0].location_id;

            if (res.data[0].agreement_signed == "T") {
              self.formlist.agreement_signed = true;
            } else {
              self.formlist.agreement_signed = false;
            }

            if (res.data[0].status == "ACTIVE") {
              self.formlist.status = true;
            } else {
              self.formlist.status = false;
            }

            if (res.data[0].status == "ACTIVE") {
              this.institutionStatus = true;
            } else {
              this.institutionStatus = false;
            }

            if (res.data[0].key_acount == "T") {
              self.formlist.key_acount = true;
            } else {
              self.formlist.key_acount = false;
            }

            if (res.data[0].key_acount == "T") {
              this.institutionKey_acount = true;
            } else {
              this.institutionKey_acount = false;
            }

            this.center = [res.data[0].lng, res.data[0].lat];

            this.getDistributorContactList();
          } else {
            Message.error(res.message);
          }
        });
      },
      getCountyData(city_id) {
        this.pushlist.county_id = "";
        this.formlist.county_id = "";
        this.getCountyList(city_id);
      },
      getCountyList(city_id) {
        this.CountyList = [];
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          city_id: city_id,
        };
        http.post("/wapi/v1/getCountyList", data).then((res) => {
          if (res.success) {
            this.CountyList = res.data;
          }
        });
      },
      async getDistributorInfo() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.distributor_id,
        };
        let self = this;
        await http.post("/wapi/Distributor/getDistributorInfo", data).then((res) => {
          if (res.success) {
            this.is_data = true;
            self.ContactList.address = res.data[0].address;
            self.ContactList.city_id = res.data[0].city_id;
            self.ContactList.city_name = res.data[0].city_name;
            self.ContactList.county_id = res.data[0].county_id;
            self.ContactList.county_name = res.data[0].county_name;
            self.ContactList.comments = res.data[0].comments;
            self.ContactList.distributor_grade = res.data[0].distributor_grade;
            self.ContactList.distributor_grade_name = res.data[0].distributor_grade_name;
            self.ContactList.distributor_id = res.data[0].distributor_id;
            self.ContactList.distributor_name = res.data[0].distributor_name;
            self.ContactList.distributor_type = res.data[0].distributor_type;
            self.ContactList.distributor_type_name = res.data[0].distributor_type_name;
            self.ContactList.lat = res.data[0].lat;
            self.ContactList.lng = res.data[0].lng;
            self.ContactList.location_id = res.data[0].location_id;
            self.ContactList.postcode = res.data[0].postcode;
            self.ContactList.province_id = res.data[0].province_id;
            self.ContactList.province_name = res.data[0].province_name;
            self.ContactList.telephone = res.data[0].telephone;
            self.ContactList.tenant_id = res.data[0].tenant_id;
            self.ContactList.website = res.data[0].website;
            self.ContactList.distributor_code = res.data[0].distributor_code;
            self.ContactList.account_level = res.data[0].account_level;
            self.ContactList.account_level_name = res.data[0].account_level_name;
            self.ContactList.account_verified = res.data[0].account_verified;
            this.Retailstore_id = res.data[0].distributor_id;

            self.formlist.address = res.data[0].address;
            self.formlist.city_id = res.data[0].city_id;
            self.formlist.city_name = res.data[0].city_name;
            self.formlist.county_id = res.data[0].county_id;
            self.formlist.county_name = res.data[0].county_name;
            self.formlist.comments = res.data[0].comments;
            self.formlist.distributor_grade = res.data[0].distributor_grade;
            self.formlist.distributor_grade_name = res.data[0].distributor_grade_name;
            self.formlist.distributor_id = res.data[0].distributor_id;
            self.formlist.distributor_name = res.data[0].distributor_name;
            self.formlist.distributor_type = res.data[0].distributor_type;
            self.formlist.distributor_type_name = res.data[0].distributor_type_name;
            self.formlist.lat = res.data[0].lat;
            self.formlist.lng = res.data[0].lng;
            self.formlist.location_id = res.data[0].location_id;
            self.formlist.postcode = res.data[0].postcode;
            self.formlist.province_id = res.data[0].province_id;
            self.formlist.province_name = res.data[0].province_name;
            self.formlist.telephone = res.data[0].telephone;
            self.formlist.tenant_id = res.data[0].tenant_id;
            self.formlist.website = res.data[0].website;
            self.formlist.distributor_code = res.data[0].distributor_code;
            self.formlist.distributor_grade_name = res.data[0].distributor_grade_name;
            self.formlist.agreement_stage = res.data[0].agreement_stage;
            self.formlist.account_level = res.data[0].account_level;
            self.formlist.account_verified = res.data[0].account_verified;

            self.distributor_name = res.data[0].distributor_name;
            self.address = res.data[0].address;
            self.location_id = res.data[0].location_id;

            if (res.data[0].agreement_signed == "T") {
              self.formlist.agreement_signed = true;
            } else {
              self.formlist.agreement_signed = false;
            }

            if (res.data[0].status == "ACTIVE") {
              self.formlist.status = true;
            } else {
              self.formlist.status = false;
            }

            if (res.data[0].status == "ACTIVE") {
              this.institutionStatus = true;
            } else {
              this.institutionStatus = false;
            }

            if (res.data[0].key_acount == "T") {
              self.formlist.key_acount = true;
            } else {
              self.formlist.key_acount = false;
            }

            if (res.data[0].key_acount == "T") {
              this.institutionKey_acount = true;
            } else {
              this.institutionKey_acount = false;
            }

            this.center = [res.data[0].lng, res.data[0].lat];
            this.getLocation();
          } else {
            Message.error(res.message);
          }
        });
      },

      async getDistributorContactList() {
        let data = {
          //                    tenant_id:"2189100436",
          //                    distributor_id:this.distributor_id
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.distributor_id,
        };
        let self = this;
        await http.post("/wapi/Distributor/getDistributorContactList", data).then((res) => {
          if (res.success) {
            self.listData = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },
      async getProList() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        };

        let self = this;
        await http.post("/wapi/Institution/getProList", data).then((res) => {
          if (res.success) {
            self.prolist = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },

      async getJobtList() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        };

        let self = this;
        await http.post("/wapi/Institution/getJobtList", data).then((res) => {
          if (res.success) {
            self.jobtList = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },

      async updateDistributorContact() {
        let status = "";
        if (this.clerkClass.status == true) {
          status = "ACTIVE";
        } else {
          status = "INACTIVE";
        }
        let data = {
          //                    tenant_id:"2189100436",
          //                    distributor_id:this.distributor_id
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.clerkClass.distributor_id,
          contact_id: this.clerkClass.contact_id,
          contact_name: this.clerkClass.contact_name,
          contact_code: this.clerkClass.contact_code,
          gender: this.clerkClass.gender,
          birthday: this.clerkClass.birthday,
          hobby: this.clerkClass.hobby,
          email: this.clerkClass.email,
          mobile: this.clerkClass.mobile,
          status: status,
          user_id: this.$store.getters.getUser.user_id,
          job_title: this.clerkClass.job_title,
          department: this.clerkClass.department,
        };
        //                let self = this
        await http.post("/wapi/Distributor/updateDistributorContact", data).then((res) => {
          if (res.success) {
            //                        self.listData=res.data
            this.getDistributorContactList();
            this.dialogVisible3 = false;
          } else {
            Message.error(res.message);
          }
        });
      },

      async addDistributorContact() {
        let status = "";
        if (this.clerkClass.status == true) {
          status = "ACTIVE";
        } else {
          status = "INACTIVE";
        }
        let data = {
          //                    tenant_id:"2189100436",
          distributor_id: this.distributor_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
          contact_name: this.clerkadd.contact_name,
          contact_code: this.clerkadd.contact_code,
          gender: this.clerkadd.gender,
          birthday: this.clerkadd.birthday,
          hobby: this.clerkadd.hobby,
          email: this.clerkadd.email,
          mobile: this.clerkadd.mobile,
          status: status,
          user_id: this.$store.getters.getUser.user_id,
          job_title: this.clerkadd.job_title,
          department: this.clerkadd.department,
        };
        //                let self = this
        await http.post("/wapi/Distributor/addDistributorContact", data).then((res) => {
          if (res.success) {
            //                        self.listData=res.data
            Message({
              type: "success",
              message: "保存成功",
            });
            this.getDistributorContactList();
          } else {
            Message.error(res.message);
          }
        });
      },

      async setDistributorStatus(status) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          distributor_id: this.distributor_id,
          status: status,
        };

        //                let self = this
        await http.post("/wapi/Distributor/setDistributorStatus", data).then((res) => {
          if (res.success) {
            //                        self.jobtList=res.data
          } else {
            Message.error(res.message);
          }
        });
      },

      async getDistributorTypeList() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
        };

        let self = this;
        await http.post("/wapi/Distributor/getDistributorTypeList", data).then((res) => {
          if (res.success) {
            self.TypeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },
      
      async getAccountList(b) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          type: "ACCOUNT_LEVEL",
        };

        let self = this;
        await http.post("/crm/dictionary/getDictionaryByType", data).then((res) => {
          if (res.success) {
            debugger;
            self.AccountLevelList = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },
      async getDistributorGardeList(b) {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          key: b,
        };

        let self = this;
        await http.post("/wapi/Distributor/getDistributorGardeList", data).then((res) => {
          if (res.success) {
            self.GardeList = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },
      fangfa2(b) {
        this.getDistributorGardeList(b);
        this.pushlist.distributor_grade_name = "";
        this.formlist.distributor_grade_name = "";
      },
      async getCityList(province_id) {
        let data = {
          province_id: province_id,
          tenant_id: this.$store.getters.getUser.tenant_id,
        };
        let self = this;
        await http.post("/wapi/City/getCityList", data).then((res) => {
          if (res.success) {
            self.CityList = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },

      fangfa(a) {
        this.formlist.city_id = "";
        this.pushlist.city_id = "";
        this.formlist.county_id = "";
        this.pushlist.county_id = "";
        this.getCityList(a);
      },

      // citychange(a) {
      //   this.formlist.county_id = "";
      //   this.pushlist.county_id = "";
      //   this.getCountyList(a);
      // },
      async updateDistributor() {
        let status = "";
        if (this.formlist.status == true) {
          status = "ACTIVE";
        } else {
          status = "INACTIVE";
        }

        let key_acount = "";
        if (this.formlist.key_acount == true) {
          key_acount = "T";
        } else {
          key_acount = "F";
        }

        let status2 = "";
        if (this.formlist.agreement_signed == true) {
          status2 = "T";
        } else {
          status2 = "F";
        }
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.formlist.distributor_id,
          distributor_name: this.formlist.distributor_name,
          distributor_code: this.formlist.distributor_code,
          distributor_type: this.formlist.distributor_type,
          distributor_grade: this.formlist.distributor_grade_name,
          province_id: this.formlist.province_id,
          city_id: this.formlist.city_id,
          county_id: this.formlist.county_id,
          address: this.formlist.address,
          telephone: this.formlist.telephone,
          postcode: this.formlist.postcode,
          website: this.formlist.website,
          comments: this.formlist.comments,
          agreement_signed: status2,
          agreement_stage: this.formlist.agreement_stage,
          user_id: this.$store.getters.getUser.user_id,
          key_acount: key_acount,
          account_level: this.formlist.account_level,
          account_verified: this.formlist.account_verified,
          status: status,
        };
        debugger;
        //  hello
        await http.post("/wapi/Distributor/updateDistributor", data).then((res) => {
          if (res.success) {
            //                        self.GardeList=res.data
            this.getDistributorInfo();
            this.getDistributorList("edit");
            this.dialogVisible2 = false;
          } else {
            Message.error(res.message);
          }
        });
      },

      async addDistributor() {
        let status = "";
        if (this.pushlist.status == true) {
          status = "ACTIVE";
        } else {
          status = "INACTIVE";
        }

        let key_acount = "";
        if (this.pushlist.key_acount == true) {
          key_acount = "T";
        } else {
          key_acount = "F";
        }
        let status2 = "";
        if (this.pushlist.agreement_signed == true) {
          status2 = "T";
        } else {
          status2 = "F";
        }
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_name: this.pushlist.distributor_name,
          distributor_code: this.pushlist.distributor_code,
          distributor_type: this.pushlist.distributor_type,
          distributor_grade: this.pushlist.distributor_grade,
          province_id: this.pushlist.province_id,
          city_id: this.pushlist.city_id,
          county_id: this.pushlist.county_id,
          address: this.pushlist.address,
          telephone: this.pushlist.telephone,
          postcode: this.pushlist.postcode,
          website: this.pushlist.website,
          comments: this.pushlist.comments,
          user_id: this.$store.getters.getUser.user_id,
          agreement_signed: status2,
          agreement_stage: this.pushlist.agreement_stage,
          status: status,
          key_acount: key_acount,
          account_level: this.pushlist.account_level,
          account_verified: this.pushlist.account_verified,
        };

        //                let self = this
        await http.post("/wapi/Distributor/addDistributor", data).then((res) => {
          if (res.success) {
            //                        self.GardeList=res.data

            this.province_id = res.data[0].province_id;
            this.city_id = res.data[0].city_id;
            this.county_id = res.data[0].county_id;
            this.distributor_id = res.data[0].distributor_id;
            this.getDistributorList("edit");
            this.dialogVisible5 = false;
            this.$refs.tree.setCurrentKey(this.city_id);

            this.getDistributorListAcion();

            this.getDistributorInfo(this.distributor_id);

            this.dialogVisible5 = false;
          } else {
            Message.error(res.message);
            this.dialogVisible5 = true;
          }
        });
      },

      async setDistributorLocation() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.distributor_id,
          distributor_name: this.distributor_name,
          address: this.address,
          location_id: this.location_id,
          lat: this.edit_markers.position[1],
          lng: this.edit_markers.position[0],
          user_id: this.$store.getters.getUser.user_id,
        };

        await http.post("/wapi/Distributor/setDistributorLocation", data).then((res) => {
          if (res.success) {
            this.getDistributorInfo();
          } else {
            Message.error(res.message);
          }
        });
      },
      async getDictionaryListByKOL_LEVEL2() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          category: "DISTRIBUTOR_AGREEMENT_STAGE",
        };
        let self = this;
        await http.post("/wapi/v1/getDictionaryListByCategory", data).then((res) => {
          if (res.success) {
            self.AGREEMENT_STAGE = res.data;
          } else {
            Message.error(res.message);
          }
        });
      },
      async getLocation() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          reference_id: this.Retailstore_id,
          reference_obj: "DISTRIBUTOR",
        };
        await http.post("/wapi/Institution/getLocation", data).then((res) => {
          if ((res.success = true)) {
            this.locationInfo = res.data;
            this.widthLocation = (this.locationInfo.length + 1) * 350 + "px";
            this.centers = [];
            if (this.locationInfo.length > 0) {
              for (var i = 0; i < this.locationInfo.length; i++) {
                this.center = [res.data[0].lng, res.data[0].lat];
                this.centers.push({
                  position: [res.data[i].lng, res.data[i].lat],
                  template: `<div style="width: 22px;color:#fff;height: 30px;text-align: center; line-height: 20px; background:url(${imgUrl})">${i + 1}</div>`,
                });
              }
            } else {
              this.center = [this.city_lng, this.city_lat];
              this.zoom = 10;
              this.centers.length = 0;
              this.edit_markers.position.length = 0;
            }
          }
        });
      },
      locationLeftBut() {
        if (this.mydiv > 1) {
          this.mydiv = this.mydiv - 1;
          this.marginValue = this.marginValue + 312;
        } else if (this.mydiv == 1 && this.marginValue == 0) {
          this.mydiv = this.mydiv - 1;
          this.marginValue = 0;
        } else if (this.mydiv == 1 && this.marginValue < 0) {
          this.mydiv = this.mydiv - 1;
          this.marginValue = 0;
        }
        this.center = [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat];
      },
      locationRightBut() {
        if (this.mydiv < this.locationInfo.length - 1) {
          this.mydiv = this.mydiv + 1;
          this.marginValue = this.marginValue - 312;
        } else {
          this.marginValue = this.marginValue;
        }
        this.center = [this.locationInfo[this.mydiv].lng, this.locationInfo[this.mydiv].lat];
      },
      addLocation() {
        this.formapLocation = {
          location_name: "",
          address: "",
          location_id: "",
          status: this.locationInfo.length === 0 ? "ACTIVE" : "INACTIVE",
          location_status: "ACTIVE",
        };
        this.searchStr = "";
        this.markers2.length = 0;
        this.edit_markers.position.length = 0;
      },
      InstitutionClient(item, j) {
        this.mydiv = j;
        this.marginValue = -(j * 312);
        this.center = [item.lng, item.lat];
      },
      editorLocation(item) {
        this.markers2.length = 0;
        this.formapLocation = {
          location_name: item.location_name,
          address: item.address,
          location_id: item.location_id,
          status: item.primary == "T" ? "ACTIVE" : "INACTIVE",
          location_status: item.location_status,
        };
        this.mapCenter = [item.lng, item.lat];
        this.markers2.push([item.lng, item.lat]);
        this.edit_markers.position = [item.lng, item.lat];
      },
      async baocunLocation() {
        if (this.formapLocation.location_id) {
          //编辑
          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            location_name: this.formapLocation.location_name,
            location_id: this.formapLocation.location_id,
            status: this.formapLocation.status,
            location_status: this.formapLocation.location_status,
            reference_obj: "DISTRIBUTOR",
            address: this.formapLocation.address,
            reference_id: this.Retailstore_id,
            lng: this.edit_markers.position[0],
            lat: this.edit_markers.position[1],
          };
          await http.post("/wapi/Institution/setLocation", data).then((res) => {
            if ((res.success = true)) {
              Message({
                type: "success",
                message: "更新成功",
              });
              this.getLocation();
            }
          });
        } else {
          //新增
          let data = {
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            location_name: this.formapLocation.location_name,
            address: this.formapLocation.address,
            status: this.formapLocation.status,
            location_status: this.formapLocation.location_status,
            reference_obj: "DISTRIBUTOR",
            reference_id: this.Retailstore_id,
            lng: this.edit_markers.position[0],
            lat: this.edit_markers.position[1],
          };
          await http.post("/wapi/Institution/setLocation", data).then((res) => {
            if ((res.success = true)) {
              Message({
                type: "success",
                message: "保存成功",
              });
              this.mydiv = 0;
              this.getLocation();
            }
          });
        }
      },
      getpois(pois) {
        this.edit_markers.position = pois;
        // Message({
        //     type: 'success',
        //     message: '坐标已更新'
        // })
      },
      // handleChange3(file, fileList) {
      //
      //   this.file2 = file.name
      //   const nameArr = file.name.split('.')
      //   const extension = nameArr[nameArr.length - 1] === 'xlsx'
      //   const isLt2M = file.size / 1024 / 1024 < 10
      //   if (!extension) {
      //     this.file = ''
      //     this.fileList3 = []
      //     Message({
      //       showClose: true,
      //       message: '上传模板只能是xlsx',
      //       type: 'error'
      //     })
      //   }
      //   if (!isLt2M) {
      //     this.file = ''
      //     this.fileList3 = []
      //     Message({
      //       showClose: true,
      //       message: '传模板大小不能超过 10MB',
      //       type: 'error'
      //     })
      //   }
      //   this.isUpload3 = true
      //
      //   return extension && isLt2M
      // },
      async handleChange3(file, fileList) {
        this.loading = true;
        this.$refs.upload3.clearFiles();
        this.loadingText = "文件解析中";
        let res = await this.getParsingFile(file.raw);

        setTimeout(() => {
          this.loading = false;
          this.loadingText = "拼命加载中";
        }, 1000);
        if (!res.status) {
          this.$message.error(res.message);
          this.fileList3 = [];
          return;
        }

        if (res.data.length === 0 || res.data[0].length !== 7 || res.data[0][0].trim() !== "经销商编码") {
          this.$message.error("模板错误，请选择正确的模板");
          this.fileList3 = [];
          return false;
        }
        if (res.data.slice(1).length === 0) {
          this.$message.error("导入数据必须大于0条");
          this.fileList3 = [];
          return false;
        }
        if (fileList.length !== 0 && res) {
          this.file2 = file.name;
        }
        this.excelData3 = res.data;
        //
        // this.file2 = file.name
        // const nameArr = file.name.split('.')
        // const extension = nameArr[nameArr.length-1] === 'xlsx'
        // const isLt2M = file.size / 1024 / 1024 < 10
        // if (!extension) {
        //     this.file = ''
        //     this.fileList3 = []
        //     Message({
        //         showClose: true,
        //         message: '上传模板只能是xlsx',
        //         type: 'error'
        //     })
        // }
        // if (!isLt2M) {
        //     this.file = ''
        //     this.fileList3 = []
        //     Message({
        //         showClose: true,
        //         message: '传模板大小不能超过 10MB',
        //         type: 'error'
        //     })
        // }
        // this.isUpload3 = true
        //
        // return extension && isLt2M
      },

      async handleSuccess3(res, file) {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (res.success) {
          try {
            //                        var user = this.$store.getters.getUser

            let data = {
              user_id: this.$store.getters.getUser.user_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              path: res.data,
            };

            await http.post("/wapi/excel/loaction2", data).then((res) => {
              loading.close();
              if (res.success) {
                if (res.data) {
                  let onOff = true;
                  let array = [];
                  for (let i = 0; i < res.data.length; i++) {
                    if (res.data[i].success === false) {
                      onOff = false;
                      array.push(res.data[i]);
                    }
                  }
                  if (onOff === false) {
                    this.fileList3 = [];
                    this.dialogLoaction = true;
                    this.locationDate = array;
                    return;
                  } else {
                    this.closeModal2();
                    if (res.data.length > 0) {
                      Message({
                        type: "success",
                        message: "导入成功",
                      });
                    } else {
                      this.Mechanism3 = [...res.data];
                      this.arr3 = [...res.data];
                    }
                  }
                } else {
                  this.fileList3 = [];

                  Message({
                    type: "error",
                    message: res.message,
                  });
                }
              } else {
                this.fileList4 = [];

                Message({
                  type: "error",
                  message: "导入失败",
                });
              }

              this.loading = false;
            });
          } catch (err) {
            loading.close();
            Message.error("导入失败！");
          }
        } else {
          loading.close();
          Message.error("导入失败！");
        }
      },
      // imortDataClick3() {
      //   if (this.isUpload3) {
      //     this.$refs.upload3.submit()
      //   } else {
      //     Message({
      //       showClose: true,
      //       message: '导入模板不能为空',
      //       type: 'error'
      //     })
      //   }
      // },
      async imortDataClick3() {
        if (this.excelData3.length === 0) {
          this.$message.error("请选择导入模板！");
          return false;
        }
        this.loading = true;
        this.loadingText = `正在导入数据0%(0/${this.excelData3.length - 1})`;
        this.errData3 = "";
        this.record = [];
        let herder = this.excelData3[0];
        let res = await this.importData3(herder, this.excelData3.slice(1), 0, 500, this.excelData3.length - 1);

        if (!res) {
          this.$message.error("导入失败");
          this.loading = false;
          this.loadingText = "拼命加载中";
        } else {
          if (this.record.some((item) => item)) {
            this.$message.success("导入成功");
            this.loadingText = "拼命加载中";
            this.loading = false;
            if (this.errData3.length > 0) {
              this.dialogLoaction = true;
              this.locationDate = this.errData3.slice(0, 100);
            }
          } else {
            this.$message.error("导入失败");
            this.loading = false;
            this.loadingText = "拼命加载中";
          }
        }
        // if (this.isUpload3) {
        //     this.$refs.upload3.submit()
        // } else {
        //     Message({
        //         showClose: true,
        //         message: '导入模板不能为空',
        //         type: 'error'
        //     })
        // }
      },
      async importData3(herder, excelData = [], page = 0, limit = 1000, size = 0) {
        try {
          if (page * limit >= size) {
            return true;
          }
          let data = {
            progressNum: page * limit,
            user_id: this.$store.getters.getUser.user_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
          };

          let response = await http.post("/wapi/excel/loaction2", data);
          if (!response) {
            return false;
          }
          if (response.statusCode === 502) {
            return await this.importData3(herder, excelData, page, limit, size);
          }
          this.loadingText = "正在导入数据" + (((page + 1) * limit) / size > 1 ? "100%" : ((((page + 1) * limit) / size) * 100).toFixed(0) + "% ");
          let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`;
          this.loadingText += progressText;

          if (response.success) {
            this.record.push(true);
            if (response.data) {
              if (!this.errData3) {
                this.errData3 = [];
              }
              this.errData3 = [...this.errData3, ...response.data];
            }
          } else {
            this.record.push(false);
          }
          return await this.importData3(herder, excelData, page + 1, limit, size);
        } catch (e) {
          return false;
        }
      },
      async handleExportData6() {
        try {
          this.loading = true;
          let tHeader = ["经销商编码", "经销商名称", "位置编码", "位置名称", "地址", "经度", "纬度", "是否启用", "报错信息"];
          let names = ["distributor_code", "distributor_name", "location_code", "location_name", "address", "longitude", "latitude", "status", "message"];
          let data = this.obj_to_arr(names, this.errData3);
          this.loadingText = `正在下载错误数据0% (0 / ${data.length})`;
          this.downloadErrorExcel(tHeader, data, 0, 20000);
          //错误数据
          this.loading = false;
          this.loadingText = "拼命加载中";
        } catch (err) {
          this.loading = false;
          this.loadingText = "拼命加载中";
          this.$message.error("下载失败！");
        }
        // try {
        //     import('@/vendor/Export2Excel').then(excel => {
        //         const tHeader = ['机构编码','机构名称','地址','经度', '纬度','报错信息']
        //         const filterVal = [
        //             'code',
        //             'institutions_name',
        //             'address',
        //             'longitude',
        //             'latitude',
        //             'message'
        //         ]
        //         let arr=[...this.locationDate]
        //
        //
        //         const list = arr
        //         const data = this.formatJson(filterVal, list)
        //
        //         excel.export_json_to_excel({
        //             header: tHeader,
        //             data,
        //             filename: '报错信息表',
        //             autoWidth: this.autoWidth
        //         })
        //     })
        //     this.loading = false
        //     this.dialogLoaction=false
        // } catch (err) {
        //     this.loading = false
        //     this.error()
        // }
      },

      // handleExportData6() {
      //   try {
      //     import('@/vendor/Export2Excel').then(excel => {
      //       const tHeader = ['机构编码', '机构名称', '地址', '经度', '纬度', '报错信息']
      //       const filterVal = [
      //         'code',
      //         'institutions_name',
      //         'address',
      //         'longitude',
      //         'latitude',
      //         'message'
      //       ]
      //       let arr = [...this.locationDate]
      //
      //
      //       const list = arr
      //       const data = this.formatJson(filterVal, list)
      //
      //       excel.export_json_to_excel({
      //         header: tHeader,
      //         data,
      //         filename: '报错信息表',
      //         autoWidth: this.autoWidth
      //       })
      //     })
      //     this.loading = false
      //     this.dialogLoaction = false
      //   } catch (err) {
      //     this.loading = false
      //     this.error()
      //   }
      // },
      xiazai3() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          province_id: this.form.position,
          reference_obj: "DISTRIBUTOR",
        };
        let self = this;
        http
          .post("/wapi/derive/deriveCoordinates2", data)
          .then((res) => {
            self.coordinatesList = res;
            this.handleExportData7();
          })
          .catch((err) => {
            Message({
              type: "error",
              message: "下载失败",
            });
          });
      },
      handleExportData7() {
        try {
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          //                    this.deriveHcpList=[]
          import("@/vendor/Export2Excel").then((excel) => {
            const tHeader = ["经销商编码", "经销商名称", "位置名称", "地址", "经度", "纬度", "是否启用", "是否重点客户"];
            const filterVal = ["institution_code", "institution_name", "location_name", "address", "longitude", "latitude", "status", "key_acount"];

            const list = this.coordinatesList;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.retailStoreData_location,
              autoWidth: this.autoWidth,
            });
          });
          loading.close();
        } catch (err) {
          loading.close();
          this.error();
        }
      },
      async getExtendedInfo() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          distributor_id: this.distributor_id,
        };
        await http.post("/wapi/Distributor/getExtendedInfo", data).then((res) => {
          if (res.success) {
            this.extendedInfo = res.data;
            if (this.extendedInfo.length > 0) {
              for (let i = 0; i < this.extendedInfo.length; i++) {
                this.extendedInfo[i].fieldArray.forEach((item) => {
                  if (item.input_type === "LIST" && item.multiple === "T" && item.field_value.indexOf("|") == -1 && item.field_value !== "") {
                    item.field_value = [item.field_value];
                  }
                  if (item.input_type === "LIST" && item.field_value.indexOf("|") !== -1) {
                    item.field_value = item.field_value.split("|");
                  }
                  if (item.input_type === "LIST" && item.multiple === "T" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (item.input_type === "TABLE" && item.field_value !== "") {
                    item.field_value = JSON.parse(item.field_value);
                  }
                  if (item.input_type === "TABLE" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                    item.field_value = "F";
                  }
                });
              }
            }
          } else {
            Message.error(res.message);
          }
        });
      },
      async updateExtendedInfo() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          distributor_id: this.distributor_id,
          ExtensionArray: this.extendedInfo[this.tabIndex - 1].fieldArray,
        };
        await http.post("/wapi/Distributor/setExtendedList", data).then((res) => {
          if (res.success) {
            Message({
              type: "success",
              message: "保存成功",
            });
            this.getExtendedInfo();
            this.dialogVisible2 = false;
            this.isfalse = false;
            this.extendedInfo[this.tabIndex - 1].fieldArray = [];
          } else {
            Message.error(res.message);
          }
        });
      },
      async getContactExtendedInfo() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          contact_id: this.contact_id,
        };
        await http.post("/wapi/Distributor/getContactExtendedInfo", data).then((res) => {
          if (res.success) {
            this.extendedInfo1 = res.data;
            if (this.extendedInfo1.length > 0) {
              for (let i = 0; i < this.extendedInfo1.length; i++) {
                this.extendedInfo1[i].fieldArray.forEach((item) => {
                  if (item.input_type === "LIST" && item.multiple === "T" && item.field_value.indexOf("|") == -1 && item.field_value !== "") {
                    item.field_value = [item.field_value];
                  }
                  if (item.input_type === "LIST" && item.field_value.indexOf("|") !== -1) {
                    item.field_value = item.field_value.split("|");
                  }
                  if (item.input_type === "LIST" && item.multiple === "T" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (item.input_type === "TABLE" && item.field_value !== "") {
                    item.field_value = JSON.parse(item.field_value);
                  }
                  if (item.input_type === "TABLE" && item.field_value === "") {
                    item.field_value = [];
                  }
                  if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                    item.field_value = "F";
                  }
                });
              }
            }
          } else {
            Message.error(res.message);
          }
        });
      },
      async updateContactExtendedInfo() {
        let data = {
          tenant_id: this.$store.getters.getUser.tenant_id,
          user_id: this.$store.getters.getUser.user_id,
          distributor_id: this.distributor_id,
          contact_id: this.contact_id,
          ExtensionArray: this.extendedInfo1[this.tabIndex - 1].fieldArray,
        };
        await http.post("/wapi/Distributor/setContactExtendedList", data).then((res) => {
          if (res.success) {
            Message({
              type: "success",
              message: "保存成功",
            });
            this.dialogVisible3 = false;
            this.extendedInfo1[this.tabIndex - 1].fieldArray = [];
          } else {
            Message.error(res.message);
          }
        });
      },
      changeInstitution() {
        for (var i = 0; i < this.dataList.length; i++) {
          if (this.form.name == this.dataList[i].id) {
            this.retailStoreData_name = "经销商数据（" + this.dataList[i].label + "）";
          }
        }
      },
      changeInstitution1() {
        for (var i = 0; i < this.dataList.length; i++) {
          if (this.form.position == this.dataList[i].id) {
            this.retailStoreData_location = "经销商坐标数据（" + this.dataList[i].label + "）";
          }
        }
      },
      changeInstitution2() {
        for (var i = 0; i < this.dataList.length; i++) {
          if (this.form.title == this.dataList[i].id) {
            this.retailStoreData_title = "联系人数据（" + this.dataList[i].label + "）";
          }
        }
      },
      clickExtension() {
        this.dialogVisible2 = false;
        this.isDetail = false;
        this.photoIdArray = [];
        this.imgArray = [];
        setTimeout(() => {
          this.isfalse = false;
        }, 100);
      },
      bianji() {
        this.getAdministrativeList();
        this.getProductList();
        this.isfalse = true;
        this.dialogVisible2 = true;
        this.activeName2 = "first";
        this.getCityList(this.formlist.province_id);
        this.getCountyList(this.formlist.city_id);
        this.getDistributorGardeList(this.formlist.distributor_type);
        this.getImgInfo();
        this.getFilesInfo();
      },
      openDetail() {
        this.isDetail = true;
        this.type = "add";
        this.categoryAgenda = {
          reference_obj: "CLIENT",
          reference_id: "com.saasyun.android",
          credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
          tenant_id: this.$store.getters.getUser.tenant_id,
          username: this.$store.getters.getUser.username,
          user_id: this.$store.getters.getUser.user_id,
          event_obj: "DISTRIBUTOR",
          event_id: this.formlist.distributor_id,
          category: "PICTURE",
          data: this.uuidAgenda,
        };
        this.tags = [];
      },
      openDetail1() {
        this.isDetail1 = true;
      },
      tagClose(tag) {
        this.tags.splice(this.tags.indexOf(tag), 1);
        this.editTags.push(tag);
      },
      getUuidAgenda() {
        var s = [];
        var hexDigits = "0123456789abcdef";

        for (var i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        this.uuidAgenda = uuid;
      },
      beforeUpload(file) {
        if (/\.(jpg|png|jpeg)$/.test(file.name)) {
          this.$refs["photoUpload"].submit();
        } else {
          this.$message({
            type: "error",
            message: "图片格式只能为jpg/png/jpeg",
          });
        }
      },
      getPhotoIdAgenda(res, file, fileList) {
        // console.log(res,111)
        let num = this.imgArray.length;
        if (num == 0) {
          this.photoIdObj.sort = 1;
        } else {
          this.photoIdObj.sort = num + 1;
        }
        this.photoIdObj.photo_id = res.data.s3filename;
        this.photoIdArray.push({
          photo_id: this.photoIdObj.photo_id,
          sort: this.photoIdObj.sort,
        });
      },
      async submitPhoto() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            distributor_id: this.formlist.distributor_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
            photoIdArray: this.photoIdArray,
            type: this.type,
            tags: this.tags,
            deleteTags: this.editTags,
            selectPhotoId: this.selectPhotoId,
          };
          await http.post("/wapi/Distributor/addPhoto", data).then((res) => {
            if (res.data.success) {
              this.imgArray = [];
              this.getImgInfo();
              loading.close();
            }
          });
          this.$refs.photoUpload.clearFiles();
          this.tags = [];
          this.editTags = [];
          this.photoIdArray = [];
        } catch (e) { }
      },
      addTag() {
        if (this.tagText) {
          var s = [];
          var hexDigits = "0123456789abcdef";

          for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
          }
          s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
          s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
          s[8] = s[13] = s[18] = s[23] = "-";

          var uuid = s.join("");
          let tagObj = {};
          tagObj.text = this.tagText;
          tagObj.id = uuid;
          if (this.type == "add") {
            tagObj.type = "add";
          } else if (this.type == "edit") {
            tagObj.type = "addEdit";
          }
          this.tags.push(tagObj);
          this.tagText = "";
        }
      },
      async getImgInfo() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            distributor_id: this.formlist.distributor_id,
            user_id: this.$store.getters.getUser.user_id,
          };
          await http.post("/wapi/Distributor/getImgInfo", data).then((res) => {
            if (res.data) {
              this.photo_id_arr = res.data;
              this.getImgUrl();
            }
          });
        } catch (e) {
          return e;
        }
      },
      async getImgUrl() {
        try {
          this.imgArray = [];
          for (let i = 0; i < this.photo_id_arr.length; i++) {
            let obj = this.photo_id_arr[i];
            let data = {
              reference_obj: "DISTRIBUTOR",
              reference_id: "com.saasyun.android",
              credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
              photo_ids: obj.photo_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
            };
            let res = await http.post("https://cn2.saasyun.com:15041/downloadphotos", data);

            this.imgArray.push({
              url: res.data[0].url,
              photo_id: res.data[0].photoid,
              tag: obj.tag,
            });
          }
        } catch (err) {
          console.log(`error:${err}`);
        }
      },
      closeDetail() {
        this.isDetail = false;
      },
      editPhoto(item) {
        this.isDetail = true;
        this.tags = JSON.parse(JSON.stringify(item.tag));
        for (let i = 0; i < item.tag.length; i++) {
          let obj = item.tag[i];
          obj.type = "update";
        }
        this.type = "edit";
        this.selectPhotoId = item.photo_id;
      },
      async deletePhoto() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            photo_id: this.selectPhotoId,
            distributor_id: this.formlist.distributor_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
          };
          await http.post("/wapi/Distributor/deletePhoto", data).then((res) => {
            if (res.data.success) {
              this.getImgInfo();
              this.tags = [];
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      },
      change(e) {
        this.$forceUpdate();
      },
      getUrl() {
        // return "https://cn2.saasyun.com:15028/uploadfile?tenant_id=" + this.$store.getters.getUser.tenant_id;
        return (
          "https://cn2.saasyun.com:15028/uploadfile?tenant_id=" +
          this.$store.getters.getUser.tenant_id +
          "&reference_id=com.saasyun.android&user_id=" +
          this.$store.getters.getUser.user_id
        );
      },
      openFileDetail() {
        this.fileDetail = true;
        this.type = "add";
        this.fileTags = [];
      },
      beforeFileUpload(file) {
        //console.log(file,111)
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        let size = file.size / 1024 / 1024;
        this.fileInfo.file_name = file.name;
        this.fileInfo.extension = file.name.split(".")[1];
        this.fileInfo.file_type = file.type;
        this.fileInfo.file_size = file.size;
        let num = this.fileTable.length;
        if (num == 0) {
          this.fileInfo.sort = 1;
        } else {
          this.fileInfo.sort = num + 1;
        }
        if (lastName === ".png" || lastName === ".jpg" || lastName === ".jpeg") {
          this.fileInfo.type = "PICTURE";
          if (size > 20) {
            this.error("上传图片大小不能超过 20MB!");
            return false;
          }
        } else if (lastName === ".mp4") {
          this.fileInfo.type = "VIDEO";
          if (size > 300) {
            this.error("上传视频大小不能超过 300MB!");
            return false;
          }
        } else if (lastName === ".mp3") {
          this.fileInfo.type = "AUDIO";
          if (size > 50) {
            this.error("上传音频大小不能超过 50MB!");
            return false;
          }
        } else if (lastName === ".pptx" || lastName === ".ppt") {
          this.fileInfo.type = "SLIDE";
          if (size > 50) {
            this.error("上传PPT大小不能超过 50MB!");
            return false;
          }
        } else if (lastName === ".pdf" || lastName === ".doc" || lastName === ".docx" || lastName === ".txt" || lastName === ".xlsx" || lastName === ".html") {
          this.fileInfo.type = "DOCUMENT";
          if (size > 50) {
            this.error("上传文档大小不能超过 50MB!");
            return false;
          }
        } else {
          this.error("暂不支持当前格式的文件!");
          return false;
        }
      },
      async fileSuccess(res, file, fileList) {
        this.fileInfo.fileId = res.data.s3filename;
        if (res.success) {
          this.$refs.uploadFile.clearFiles();
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          //console.log(this.fileInfo,123)
          try {
            let data = {
              distributor_id: this.formlist.distributor_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              user_id: this.$store.getters.getUser.user_id,
              fileInfo: this.fileInfo,
              category: "DISTRIBUTOR",
              type: this.type,
              tags: this.fileTags,
              deleteTags: this.editTags,
              selectFileId: this.selectFileId,
            };
            await http.post("/wapi/Distributor/addFile", data).then((res) => {
              if (res.data.success) {
                this.getFilesInfo();
                this.fileTags = [];
                this.editTags = [];
                this.fileInfo = {};
                loading.close();
              }
            });
          } catch (e) {
            return e;
          }
        }
      },
      async getFilesInfo() {
        try {
          let data = {
            tenant_id: this.$store.getters.getUser.tenant_id,
            distributor_id: this.formlist.distributor_id,
            user_id: this.$store.getters.getUser.user_id,
          };
          await http.post("/wapi/Distributor/getFilesInfo", data).then((res) => {
            if (res.success) {
              this.fileTable = res.data;
              let numObj = {
                imgNum: 0,
                slideNum: 0,
                mp4Num: 0,
                docNum: 0,
                restsNum: 0,
              };
              for (let i = 0; i < this.fileTable.length; i++) {
                let obj = this.fileTable[i];
                obj.file_name = obj.file_name.split(".")[0];
                if (obj.category == "PICTURE") {
                  numObj.imgNum++;
                } else if (obj.category == "VIDEO") {
                  numObj.mp4Num++;
                } else if (obj.category == "SLIDE") {
                  numObj.slideNum++;
                } else if (obj.category == "DOCUMENT") {
                  numObj.docNum++;
                } else {
                  numObj.restsNum++;
                }
              }
              this.statistics = numObj;
            }
          });
        } catch (e) {
          return e;
        }
      },
      async submitFiles() {
        this.$refs.uploadFile.submit();
        if (this.type == "edit") {
          const loading = this.$loading({
            lock: true,
            text: "拼命加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          try {
            let data = {
              distributor_id: this.formlist.distributor_id,
              tenant_id: this.$store.getters.getUser.tenant_id,
              user_id: this.$store.getters.getUser.user_id,
              fileInfo: this.fileInfo,
              category: "DISTRIBUTOR",
              type: this.type,
              tags: this.fileTags,
              deleteTags: this.editTags,
              selectFileId: this.selectFileId,
            };
            await http.post("/wapi/Distributor/addFile", data).then((res) => {
              if (res.data.success) {
                this.getFilesInfo();
                this.fileTags = [];
                this.editTags = [];
                this.fileInfo = {};
                loading.close();
              }
            });
          } catch (e) {
            return e;
          }
        }
      },
      editFile(index, row) {
        this.fileDetail = true;
        this.fileTags = JSON.parse(JSON.stringify(row.tag));
        for (let i = 0; i < row.tag.length; i++) {
          let obj = row.tag[i];
          obj.type = "update";
        }
        this.type = "edit";
        this.selectFileId = row.file_id;
      },
      async deleteFile() {
        const loading = this.$loading({
          lock: true,
          text: "拼命加载中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          let data = {
            file_id: this.selectFileId,
            distributor_id: this.formlist.distributor_id,
            tenant_id: this.$store.getters.getUser.tenant_id,
            user_id: this.$store.getters.getUser.user_id,
          };
          await http.post("/wapi/Distributor/deleteFile", data).then((res) => {
            if (res.data.success) {
              this.getFilesInfo();
              this.fileTags = [];
              loading.close();
            }
          });
        } catch (e) {
          return e;
        }
      },
      addFileTag() {
        if (this.fileTag) {
          var s = [];
          var hexDigits = "0123456789abcdef";

          for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
          }
          s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
          s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
          s[8] = s[13] = s[18] = s[23] = "-";
          var uuid = s.join("");
          let tagObj = {};
          tagObj.text = this.fileTag;
          tagObj.id = uuid;
          if (this.type == "add") {
            tagObj.type = "add";
          } else if (this.type == "edit") {
            tagObj.type = "addEdit";
          }
          this.fileTags.push(tagObj);
          this.fileTag = "";
        }
      },
      fileTagClose(tag) {
        this.fileTags.splice(this.fileTags.indexOf(tag), 1);
        this.editTags.push(tag);
      },
      closeFileDetail() {
        this.fileDetail = !this.fileDetail;
        this.editTags = [];
      },
      getFileSize(num) {
        let size_text;
        size_text = (parseInt(num) / 1024).toFixed(0); //kb
        if (size_text >= 1024) {
          size_text = (size_text / 1024).toFixed(0); //mb

          size_text = size_text + "MB";
        } else {
          size_text = size_text + "KB";
        }

        return size_text;
      },
      isFileType(type) {
        switch (type) {
          case "PICTURE":
            return "图片";
            break;
          case "AUDIO":
            return "音频";
            break;
          case "VIDEO":
            return "视频";
            break;
          case "SLIDE":
            return "幻灯片";
            break;
          case "DOCUMENT":
            return "文档";
            break;
        }
      },
      async downloadFile(row) {
        try {
          this.loading = true;
          let Body = new FormData();
          Body.append("credential", "58f09f86-694c-472d-bb63-64f9be093fd2");
          Body.append("file_ids", row.file_id);
          Body.append("tenant_id", this.$store.getters.getUser.tenant_id);
          Body.append("reference_obj", "CLIENT");
          Body.append("reference_id", "com.sassyun.android");
          var config = {
            headers: {
              "Content-Type": "multipart/form-data; boundary====0xKhTmLbOuNdArY",
            },
          }; //添加请求头
          await http
            .post("https://cn2.saasyun.com:15028/downloadfiles", Body, config) //
            .then((response) => {
              if (response.success) {
                console.log(response.data[0].url, 22222);
                downloadFile(response.data[0].url);
                this.loading = false;
              }
            });
        } catch (err) {
          this.loading = false;
        }
      },
    },
  };
  const downloadFile = (url) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none"; // 防止影响页面
    iframe.style.height = 0; // 防止影响页面
    iframe.src = url;
    document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
    // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
    setTimeout(() => {
      iframe.remove();
    }, 1 * 60 * 1000);
  };
</script>
<style lang="scss" module>
  .container {
    padding-top: 20px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 20px;
    background: #fff;
    height: 100%;
    box-sizing: border-box;
    /*height: 110%;*/

    .left {
      font-size: 18px;
      margin-top: -40px;
      color: #000000;

      .search {
        width: 97%;
      }

      .type {
        em {
          color: #d98f2f;
          font-size: 14px;
        }
      }

      .first {
        color: #555555;
        font-size: 14px;
      }

      .font {
        /*margin-left: 10px;*/
        line-height: 20px;
        font-size: 14px;
        color: #555555;
        position: relative;
      }
    }

    .right {
      margin-top: -20px;
      width: 100%;

      .header {
        width: 100%;
        padding-bottom: 51px;
        border-bottom: 2px dotted #e7eaec;
        margin-top: 20px;
      }

      .body {
        margin-top: 10px;
      }
    }

    ul {
      width: 100%;

      li {
        color: #555555;
        line-height: 40px;
        text-indent: 22px;
        font-size: 14px;
        cursor: pointer;
      }

      li:hover {
        background-color: #d8f6ee;
      }

      li:focus {
        background-color: #d8f6ee;
        outline-style: none;
      }
    }
  }
</style>
<style scoped>
  .amap-demo {
    height: 300px;
  }

  #div1 {
    display: none;
  }

  #div3 {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-left: 15px;
  }

  #div4 {
    margin: 0 auto;
    margin-top: 250px;
    display: block;
    text-align: center;
  }

  /* .search-box >>> .search-box-wrapper .search-btn {
}

.search-box >>> .search-box-wrapper input {
  width: 20px;
  background: url("../../assets/images/Search_Icon@.png") no-repeat;
  background-size: 20px 20px;
  background-position: right;
  margin-right: 10px;
} */

  .amap>>>.el-vue-search-box-container {
    width: 100%;
    box-shadow: none;
    border: 1px solid #ededed;
  }

  /*.treeClass >>> .el-tree-node__expand-icon{*/
  /*display: none;*/
  /*}*/
  .Myinput>>>.el-input__inner {
    margin-left: 7px;
    margin-top: 6px;
    margin-bottom: 7px;
    width: 368px;
    background-color: #ededed;
    border: 1px solid #ededed;
    height: 31px;
    text-align: center;
  }

  .subjectList>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: left;
    padding-left: 20px;
    font-weight: bolder;
  }

  .HcpClass>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: right;
    padding-right: 43px;
    font-weight: bold;
  }

  .DianClass>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: right;
    padding-right: 43px;
    font-weight: bold;
  }

  #contact>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: left;
    padding-left: 20px;
    font-weight: bold;
  }

  .SizeClass>>>.el-tree-node__label {
    font-size: 14px;
    line-height: 40px;
  }

  .SizeClass>>>.el-tree-node:focus>.el-tree-node__content {
    background-color: #d8f6ee;
  }

  .SizeClass>>>.el-tree-node__content {
    height: 40px;
  }

  .arraylist>>>.el-tabs__item {
    font-size: 14px;
  }

  .arraylist>>>.el-table .cell {
    font-size: 14px;
  }

  .MapLable>>>.el-form-item__label {
    font-size: 14px;
    text-align: left;
    color: #000;
  }

  .upload {
    width: 120px;
    height: 120px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    position: relative;
    display: inline-block;
    /*top:-15px;*/
  }

  .d1 {
    width: 30px;
    height: 1px;
    background-color: #000;
    position: absolute;
    left: 38%;
    top: 50%;
  }

  .d2 {
    width: 1px;
    height: 30px;
    background-color: #000;
    position: absolute;
    left: 50%;
    top: 38%;
  }

  .imgInfo {
    display: inline-block;
    margin-left: 10px;
    /*margin-top: 25px;*/
  }

  .imgInfo>>>.el-tag {
    height: 25px;
    line-height: 25px;
    border-radius: 5px;
  }

  .photoDetail {
    width: 100%;
    height: 300px;
    background-color: #eaf1fb;
    margin-top: 20px;
    border-radius: 5px;
  }

  .photoDetail>>>.button {
    width: 50px;
    height: 25px;
    padding: 3px;
    font-size: 8px;
  }

  .photoDetail>>>.el-upload-dragger {
    width: 300px;
    height: 160px;
  }

  .photoDetail>>>.el-input__inner {
    width: 300px;
  }

  .photoDetail>>>.el-tag {
    margin-left: 10px;
    margin-top: 10px;
  }

  .photoDetail>>>.el-tag .el-tag__close {
    color: white;
  }

  .photoDetail>>>.el-tag .el-tag__close:hover {
    background-color: #da9ee6;
  }

  .file>>>.el-input__inner {
    width: 250px;
  }

  #addTable .el-form-item__error {
    margin-left: 112px;
  }

  #addTable>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: left;
    padding-left: 20px;
    font-weight: bold;
  }

  #addTableHcp .el-form-item__error {
    margin-left: 112px;
  }

  #addTableHcp>>>.el-form-item__label {
    font-size: 14px;
    color: #000000;
    text-align: left;
    padding-left: 20px;
    font-weight: bold;
  }

  #channelCustomer>>>.channel_star label:after {
    content: "*";
    color: #f56c6c;
    margin-left: 4px;
  }
</style>
<style>
  .headerStyle>div {
    font-size: 14px;
    color: #585757;
    font-weight: bold;
  }

  .headerStyle:nth-last-of-type(2)>div {
    color: #4a90e2;
  }
</style>


// WEBPACK FOOTER //
// src/pages/staff/channel.vue